// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/info-card-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bg-signup.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/info-card-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
body {
  padding: 0 0 30px 0;
  background-color: #fafafa;
  letter-spacing: -0.3px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
  font-family: open sans, Helvetica, Arial, sans-serif;
}
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}
.layout-dashboard {
  background: transparent;
  text-align: left;
  position: relative;
  overflow-x: hidden;
}
@media (min-width: 992px) {
  .layout-dashboard {
    overflow: auto;
  }
}
.layout-dashboard .ant-layout-sider.sider-primary {
  width: 250px;
  position: fixed;
  left: 0;
  z-index: 99;
  height: 100vh;
  overflow: auto;
  margin: 0;
  padding: 33px 20px;
}
.layout-dashboard .ant-layout-sider.sider-primary .brand img {
  height: 30px;
}
.layout-dashboard .ant-layout-sider.sider-primary hr {
  margin: 18px 0;
  border: none;
  height: 1px;
  background-color: #f5f5f5;
}
.layout-dashboard .ant-layout-sider.sider-primary .brand {
  font-weight: 600;
}
.layout-dashboard .ant-layout-sider.sider-primary .brand span {
  vertical-align: middle;
  margin-left: 3px;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {
  width: auto;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline {
  border: none;
}
.layout-dashboard .ant-menu {
  background: transparent;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-inline
  .ant-menu-item,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-inline
  .ant-menu-submenu {
  margin: 0;
  overflow: visible;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu {
  padding: 0 !important;
  height: auto;
  line-height: normal;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-inline
  .ant-menu-item:after,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-inline
  .ant-menu-submenu:after {
  display: none;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-item-selected,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-item:active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item
  .ant-menu-submenu-selected,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-submenu-title:active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item
  .ant-menu-submenu:active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-item-selected,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-item:active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu
  .ant-menu-submenu-selected,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-submenu-title:active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu
  .ant-menu-submenu:active {
  background-color: transparent;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-item-selected
  .active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-item-selected
  .active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active {
  background-color: #fff;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  font-weight: 600;
}
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a {
  padding: 10px 16px;
  color: #141414;
  border-radius: 8px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .ant-menu-item.ant-menu-item-selected
  .active
  .icon,
.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .ant-menu-item
  .active
  .icon {
  background-color: #1890ff;
}
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-item-selected
  .active
  .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-item-selected
  .active
  .icon,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu
  .active
  .icon {
  background-color: #1890ff;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-right: 11px;
  vertical-align: middle;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item.ant-menu-item-selected
  .active
  svg
  path,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-item
  .active
  svg
  path,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu.ant-menu-item-selected
  .active
  svg
  path,
.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-submenu
  .active
  svg
  path {
  fill: #fff;
}
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item svg path,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu svg path {
  fill: #bfbfbf;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a:hover,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a:hover {
  color: #141414;
}

.layout-dashboard
  .ant-layout-sider.sider-primary
  .ant-menu-inline
  .ant-menu-item.menu-item-header {
  padding: 10px 16px !important;
  color: #8c8c8c;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  display: block;
}

.menu-item-header:hover {
  color: inherit;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-zero-width {
  overflow-x: hidden;
  width: 210px;
  margin: 0;
  padding: 33px 0;
}

.layout-dashboard.has-sidebar .ant-layout-sider.sider-primary .aside-footer {
  display: block;
}
.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .footer-box {
  background-color: #1890ff;
  color: #fff;
  box-shadow: none;
}
.layout-dashboard .ant-layout-sider.sider-primary .footer-box {
  background-color: #fff;
  color: #141414;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  margin-bottom: 8px;
}

.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .footer-box
  .icon {
  background-color: #fff;
}
.layout-dashboard .ant-layout-sider.sider-primary .footer-box .icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  background-color: #1890ff;
}

.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .footer-box
  h6 {
  color: #fff;
}
.layout-dashboard .ant-layout-sider.sider-primary .footer-box h6 {
  font-weight: 600;
  font-size: 16px;
  color: #141414;
  margin-bottom: 0;
}
.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .footer-box
  p {
  color: #f5f5f5;
}
.layout-dashboard .ant-layout-sider.sider-primary .footer-box p {
  color: #8c8c8c;
  font-weight: 600;
}

.layout-dashboard
  .ant-layout-sider.sider-primary.ant-layout-sider-primary
  .footer-box
  button {
  background-color: #fff;
  border-color: #f0f0f0;
  color: #141414;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box button {
  margin: 0;
}
.ant-btn-sm,
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
}
.ant-btn-sm {
  border-radius: 4px;
}

.ant-btn-sm,
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
}
.ant-btn-sm {
  border-radius: 4px;
}
.ant-btn,
.ant-radio-group .ant-radio-button-wrapper {
  font-weight: 600;
}

.layout-dashboard .ant-layout-sider.sider-primary .aside-footer {
  padding-top: 100px;
  padding-bottom: 33px;
}
.ant-menu-inline.ant-menu-root .ant-menu-item,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: block;
}

.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: hidden;
}
.layout-dashboard .ant-layout {
  background: transparent;
  position: relative;
  min-height: 100vh;
  width: 100%;
  flex-shrink: 0;
}

.layout-dashboard .ant-layout-header {
  background: transparent;
  height: auto;
  padding: 16px;
  margin: 10px 4px;
  line-height: inherit;
  border-radius: 12px;
  transition: 0.2s;
}

.layout-dashboard .ant-breadcrumb > span .ant-breadcrumb-link a {
  color: #8c8c8c;
}
.layout-dashboard .ant-breadcrumb > span:last-child .ant-breadcrumb-link {
  color: #141414;
}
.layout-dashboard .ant-page-header-heading {
  margin-top: 0;
}
.layout-dashboard .ant-page-header-heading .ant-page-header-heading-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  margin-top: 4px;
}
.layout-dashboard .header-control {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-top: 10px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown {
  background: #fff;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  border-radius: 12px;
  min-width: 276px;
  padding: 16px 8px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  ul.ant-dropdown-menu-items {
  margin: 0px;
  padding: 0px;
}

.ant-dropdown.ant-dropdown-placement-bottomRight {
  min-width: inherit !important;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-list-item {
  padding: 5px 16px;
  margin-bottom: 8px;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-avatar {
  width: 36px;
  height: 36px;
  background-color: #fafafa;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-list-item-meta-title {
  line-height: normal;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdownt
  .ant-list-item-meta-description {
  color: #8c8c8c;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-list-item-meta-description
  svg {
  width: 14px;
  height: 14px;
  fill: #8c8c8c;
  vertical-align: middle;
  margin-right: 4px;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-list-item-meta-description
  svg
  path {
  fill: #8c8c8c;
}
.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-list-item-meta-description
  span {
  vertical-align: middle;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-avatar
  .ant-avatar-string {
  top: 6px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown
  .ant-avatar
  .ant-avatar-string
  svg {
  width: 22px;
  height: 22px;
}

.h3,
.h4,
h3,
h4 {
  font-weight: 700;
  color: #141414;
}

.ant-list-item-meta-title > a {
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
}

.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.layout-dashboard .header-control .ant-btn-link {
  height: auto;
  padding: 0 7px;
  margin: 0;
  box-shadow: none;
  color: #8c8c8c;
  line-height: normal;
}

.ant-btn svg {
  margin-right: 5px;
}
.layout-dashboard .header-control svg {
  width: 20px;
  height: 20px;
}

.layout-dashboard .header-control svg path {
  fill: #141414;
}

.layout-dashboard .header-control .btn-sign-in {
  height: auto;
  padding: 0 7px;
  margin: 0;
  box-shadow: none;
  color: #8c8c8c;
}
.layout-dashboard .header-control .btn-sign-in svg {
  margin-right: 4px;
}
.layout-dashboard .header-control svg {
  vertical-align: middle;
}

.layout-dashboard .header-control .header-search {
  width: 213px;
  margin: 0 7px 0 0;
  border-radius: 6px;
  height: 40px;
  border: 1px solid #d9d9d9;
}

.layout-dashboard .header-control .anticon.anticon-search svg {
  width: 16px;
  height: 16px;
}
.layout-dashboard .header-control .header-search svg path {
  fill: #8c8c8c;
}

.settings-drawer .drawer-content > hr {
  margin: 18px 0;
  border: none;
  height: 1px;
  background-color: #f5f5f5;
}

.settings-drawer .drawer-content > h6 {
  font-size: 20px;
  margin-bottom: 0;
}
.layout-dashboard .settings-drawer .drawer-content h6 {
  font-weight: 600;
  color: #141414;
}
.settings-drawer .drawer-content p {
  color: #8c8c8c;
}
p {
  font-size: 14px;
}
.settings-drawer .drawer-content .sidebar-color h6 {
  margin-bottom: 8px;
}

.h6,
h6 {
  font-size: 16px;
}

.drawer-sidebar .ant-drawer-body {
  padding: 0px;
}

.drawer-sidebar
  .ant-drawer-body
  aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {
  margin: 0px;
}

.layout-dashboard
  .header-control
  .header-search
  .ant-input-suffix
  .ant-input-search-icon.anticon-loading,
.layout-dashboard .header-control .sidebar-toggler {
  display: block;
}
.layout-dashboard .header-control .btn-sign-in span {
  font-weight: 600;
  vertical-align: middle;
  display: none;
}

/* Old css start */
.site-layout-background {
  background: transparent;
}

header.ant-layout-header.subheader {
  background: transparent;
}

.sidemenu {
  margin-top: 20px;
  margin-left: 20px;
}

.logo img {
  width: 32px;
  margin-right: 10px;
}

.logo {
  margin-bottom: 15px;
}
.logo span {
  font-size: 16px;
  font-weight: 600;
}

hr.horizontal.dark {
  background-image: linear-gradient(
    90deg,
    transparent,
    rgb(0 0 0 / 12%),
    transparent
  );
  border: 0px;
}
hr.horizontal {
  background-color: transparent;
}
hr:not([size]) {
  height: 1px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav {
  background: transparent;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li {
  padding: 10px 16px !important;
  height: auto;
  line-height: normal;
  margin: 0px;
  border: 0px;
  font-size: 16px;
  color: #141414;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li.ant-menu-item-selected {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}
ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li.ant-menu-item-selected {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}
.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,
.ant-menu-inline.ant-menu-root
  .ant-menu-submenu-title
  > .ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: visible;
  text-overflow: ellipsis;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li::after {
  display: none;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li
  span.anticon {
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #fff;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 6px;
  font-size: 16px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li.ant-menu-item-selected
  span.anticon {
  background: #1890ff;
  color: #fff;
}

/* ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:hover {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li:hover
  span.anticon {
  background: #1890ff;
  color: #fff;
} */

.divder {
  display: table;
  width: 100%;
  padding: 10px 15px;
  color: #8c8c8c;
  font-weight: 600;
  margin: 15px 0px;
}

.ant-card.ant-card-bordered.documentation-card {
  border: 0px;
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
}
.p-15 {
  padding: 15px;
}
.card-document {
  width: 32px;
  height: 32px;
  text-align: center;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 6px;
  font-size: 19px;
  background: #1890ff;
  color: #fff;
  direction: ltr;
  margin-bottom: 15px;
}
.documentation-card h4 {
  margin: 0px;
}
.left-nav {
  /* height: 435px;
  overflow: hidden;
  overflow-y: auto;
  padding-right: 15px; */

  margin-top: 15px;
}
.ant-layout {
  background: #fafafa;
}
.pageheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rightside-top {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
}

.signin {
  white-space: nowrap;
  margin: 0px 20px;
}

.signin span.ant-avatar {
  margin-right: 9px;
}

.shadow-lg {
  box-shadow: 0 8px 26px -4px hsla(0, 0%, 8%, 0.15),
    0 8px 9px -5px hsla(0, 0%, 8%, 0.06) !important;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border: 0px;
}
.header-top h4 {
  margin: 0px;
  font-size: 20px;
}

.header-top .subtitle {
  display: block;
  font-weight: normal;
  color: #8c8c8c;
  font-size: 14px;
}

.header-top {
  margin-top: -10px;
}

.ant-drawer.ant-drawer-right.ant-drawer-open.colorside button.ant-drawer-close {
  color: #000;
}
.header-top {
  border-bottom: 1px solid rgb(140 140 140 / 7%);
  padding-bottom: 15px;
}

.rightside-top span.ant-input-affix-wrapper {
  border-radius: 4px;
}

.rightside-top span.ant-input-affix-wrapper span.ant-input-prefix {
  color: #c0c0c0;
}

.setting button.ant-btn {
  padding: 0px;
  line-height: normal;
  background: transparent;
  border: 0px;
  box-shadow: none;
}
button.ant-btn.bell {
  padding: 0px;
  border: 0px;
  background: transparent;
  box-shadow: none;
  position: relative;
}
button.ant-btn.bell strong {
  position: absolute;
  top: -1px;
  right: -5px;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #f5222d;
  border-radius: 100%;
  text-align: center;
  line-height: normal;
  font-weight: normal;
  color: #fff;
}
.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {
  width: 336px;
}

.list-notifaction ul {
  padding: 5px 10px;
  margin: 0px;
}

.list-notifaction ul li {
  display: block;
  width: 100%;

  clear: both;
  font-weight: 400;
  color: #67748e;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.list-notifaction ul li a {
  display: block;
  padding: 10px;
  border-radius: 8px;
}

.list-notifaction ul li a:hover {
  color: #252f40;
  background-color: #e9ecef;
}

.list-notifaction ul span.ant-avatar.ant-avatar-image {
  width: 48px;
  height: 48px;
  border-radius: 0.75rem;
}

.list-notifaction ul li {
  padding: 0px;
}
.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {
  border-radius: 0.75rem;
}
.list-notifaction .ant-list-item-meta-title {
  font-weight: bold;
  color: #141414;
}
.list-notifaction .ant-list-item-meta-title {
  font-weight: bold;
  color: #141414;
}

.list-notifaction .ant-avatar.ant-avatar-circle {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-notifaction ul li a span.ant-avatar-string {
  line-height: normal;
}
.bnb2 {
  color: #52c41a;
  font-weight: 700;
}
.ant-card.criclebox {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 12px;
}

.number span {
  font-weight: 600;
  color: #8c8c8c;
  font-size: 14px;
}
.number h3 {
  font-weight: 700;
  margin-bottom: 0px;
  font-size: 30px;
}

.number h3 small {
  font-weight: 600;
  font-size: 14px;
}
.icon-box {
  width: 48px;
  height: 48px;
  text-align: center;
  background: #1890ff;
  color: #fff;
  border-radius: 0.5rem;
  margin-left: auto;
  line-height: 55px;
}

.icon-box span {
  color: #fff;
  font-size: 24px;
}

.listpage {
  padding-top: 15px;
}
.bar-chart {
  background: #f8f9fa;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 8px;
}

.chart-vistior {
  margin-top: 30px;
}

.chart-vistior h5 {
  margin: 0px;
  font-weight: 700;
}
.ant-typography.lastweek {
  color: #8c8c8c;
  font-weight: 600;
}

.chart-visitor-count h4 {
  margin: 0px;
  font-weight: 700;
}

.chart-visitor-count span {
  color: rgba(0, 0, 0, 0.65);
  font-weight: 600;
}

.linechart h5 {
  font-weight: 700;
  margin: 0px;
}
.linechart {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sales ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.sales ul li:first-child span.anticon {
  color: #b37feb;
}

.sales ul li:last-child span.anticon {
  color: #1890ff;
}
.sales ul li {
  color: #8c8c8c;
  margin-bottom: 3px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}
.project-ant h4 {
  margin: 0px;
  font-size: 16px;
  font-weight: bold;
  color: #141414;
}

span.blue {
  margin-left: 5px;
  color: #1890ff;
  font-weight: 600;
}
.project-ant h5 {
  margin: 0px;
  color: #141414;
  font-weight: 700;
}

span.blue {
  margin-left: 5px;
  color: #1890ff;
  font-weight: 600;
}
.project-ant {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a {
  display: inline-block;
  padding: 7px 10px;
  color: #595959;
  border: 1px solid #d9d9d9;
  text-align: center;
  border-right: 1px solid transparent;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:last-child {
  border-right: 1px solid #d9d9d9;
  border-radius: 0px 5px 5px 0px;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:first-child {
  border-radius: 5px 0px 0px 5px;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:hover {
  color: #1890ff;
  border: 1px solid #1890ff;
}
.antd-pro-pages-dashboard-analysis-style-salesExtra a.active {
  color: #1890ff;
  border: 1px solid #1890ff;
}

.ant-list-box th {
  text-align: left;
  border-bottom: 1px solid #0000000d;
  padding: 8px 0px;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 600;
}

.ant-list-box td {
  text-align: left;
  border-bottom: 1px solid #0000000d;
  padding: 16px 25px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.d-flex {
  display: flex !important;
}
.justify-content-center {
  justify-content: center !important;
}
.flex-column {
  flex-direction: column !important;
}
.me-3 {
  margin-right: 1rem !important;
}
.tootip-img {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  border: 1px solid #fff;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.avatar-group .tootip-img + .tootip-img {
  margin-left: -10px;
}

.tootip-img:hover {
  z-index: 3;
  cursor: pointer;
}
.title-box h5 {
  margin: 0px;
}

.text-xs {
  color: #8c8c8c;
}

.percent-progress span.ant-progress-text {
  display: flex;
  margin-top: -27px;
  color: #8c8c8c;
  position: relative;
  margin-left: 0px;
}
/* .percent-progress .ant-progress-outer {
  margin-right: 0px;
  padding-right: 0px;
} */

.percent-progress .ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}
.ant-full-box {
  width: 100%;
  border: 1px dashed #d9d9d9;
  padding: 10px;
  height: auto;
  color: #141414;
  border-radius: 10px;
}
.uploadfile {
  margin-top: 15px;
}

.uploadfile .ant-upload.ant-upload-select {
  display: block;
}
.ant-timeline-item-tail {
  left: 7px;
}

.ant-list-box h5 {
  font-size: 14px;
}
.timeline-box h5 {
  margin-bottom: 0px;
  font-weight: 700;
}
.timelinelist h5 {
  font-size: 14px;
  font-weight: 600;
}

.timelinelist span {
  color: #8c8c8c;
  font-size: 12px;
}
.ant-muse span {
  color: #8c8c8c;
  font-weight: 600;
}

.ant-muse h5 {
  margin: 0px 0px 15px !important;
  font-size: 20px;
}
.bg-gradient-primary {
  background-image: linear-gradient(310deg, #2152ff, #21d4fd);
}
img {
  max-width: 100%;
}
.border10 {
  border-radius: 10px;
}
.py-4 {
  padding: 20px;
}
.mb-5 {
  margin-bottom: 3rem !important;
}
.icon-move-right .anticon-right {
  color: #40a9ff;
  margin-left: 2px;
}
.icon-move-right {
  color: #1890ff;

  display: block;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}

.gradent {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top;
  background-size: cover;
  padding: 15px;
  border-radius: 15px;
  color: #fff;
}

.gradent h5 {
  color: #fff;
}

.gradent .ant-typography {
  color: #fff;
  font-size: 20px;
}

.gradent .icon-move-right {
  color: #fff;
}

.gradent .icon-move-right .anticon-right {
  color: #fff;
}
.copyright {
  color: #8c8c8c;
  margin-top: 7px;
}
.copyright .anticon-heart {
  color: #f5222d;
  margin: 0px 5px;
}
.copyright a {
  margin: 0px 5px;
  color: #141414;
  font-weight: 700;
}
.footer-menu ul {
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer-menu ul li {
  list-style: none;
}
.footer-menu ul li a {
  padding: 0.5rem 1rem;
  display: block;
  color: #8c8c8c;
}
span.ismobile {
  display: none;
  margin-right: 15px;
  cursor: pointer;
}
@media (max-width: 992px) {
  .footer-menu ul {
    justify-content: center;
  }
  footer.ant-layout-footer {
    padding: 0px 15px;
    text-align: center;
  }
  .project-ant {
    display: block;
  }

  .ant-filtertabs {
    text-align: right;
  }
  .rightside-top span.ant-input-affix-wrapper {
    width: 200px;
  }

  .rightside-top {
    justify-content: flex-end;
  }

  header.ant-layout-header.subheader {
    padding: 0px 24px 0px 0px;
  }

  main.ant-layout-content.content-ant {
    padding-left: 0px !important;
  }

  .ant-row {
    margin-left: -12px;
    margin-right: -12px;
  }
  span.ismobile {
    display: inline-block;
  }
  .bar-chart {
    width: 100% !important;
    max-width: 100%;
  }
  .full-width {
    max-width: 100% !important;
  }
  .bar-chart {
    width: 100% !important;
  }

  .icon-move-right {
    margin-bottom: 15px;
  }
  .pageheader {
    display: block;
  }
  .ant-cret img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }
}

.sidebar-color {
  padding: 1.5rem 0px;
}
.theme-color button {
  margin-right: 8px;
  border: 0px;
  width: 20px !important;
  height: 20px !important;
  padding: 0px;
  box-shadow: none;
  visibility: visible !important;
  line-height: 20px !important;
}

.theme-color button:focus {
  box-shadow: none;
  border-color: transparent;
}

.theme-color button span {
  opacity: 0;
}

.mb-2 {
  margin-bottom: 25px;
}

.sidebarnav-color button {
  width: 100%;
  margin-right: 10px;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%), 0 2px 3px -1px rgb(0 0 0 / 7%);
  height: 40px;
}

.sidebarnav-color h5 {
  margin: 0px;
}

.sidebarnav-color span.ant-typography {
  color: #8c8c8c;
}

.sidebarnav-color .trans {
  margin-top: 1rem;
  display: flex;
}

.sidebarnav-color button:last-child {
  margin-right: 0px;
}

.ant-docment button {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
}

.viewstar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.viewstar a {
  display: inline-block;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 0em 0.25em 0.25em 0em;
  border: 1px solid #ddddde;
  border-left: 0px;
  color: #141414;
}

.viewstar a:first-child {
  color: #24292e;
  background-color: #eff3f6;
  border-color: #cfd3d6;
  background-image: linear-gradient(180deg, #fafbfc, #eff3f6 90%);
  border-radius: 0.25em 0 0 0.25em;
  border-left: 1px solid #ddddde;
}

.social {
  text-align: center;
  margin-top: 25px;
}

.social button {
  margin: 0px 5px;
  display: inline-flex;
  align-items: center;
}

.ant-thank {
  text-align: center;
  margin-top: 25px;
}
.setting-drwer {
  background: #fff;
  border-radius: 50%;
  bottom: 42px;
  right: 30px;
  font-size: 1.25rem;
  z-index: 990;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 16%);
  width: 52px;
  height: 52px;
  text-align: center;
  line-height: 60px;
  position: fixed;
  cursor: pointer;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:active {
  background: transparent;
}
.rightside-top .ant-input {
  height: 30px;
}
.aside-footer {
  padding-top: 100px;
}
.ant-card-body {
  padding: 16px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li svg path {
  color: #bfbfbf;
}

.cardbody .ant-card-body {
  padding-left: 0px;
  padding-right: 0px;
}

.ant-card.criclebox .project-ant {
  padding-left: 24px;
  padding-right: 24px;
}

.ant-card.criclebox table th {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 14px;
  padding-bottom: 14px;
}
.percent-progress .ant-progress-bg {
  height: 3px !important;
}
.uploadfile {
  padding-left: 24px;
  padding-right: 24px;
}
.ant-card.tablespace .ant-card-body {
  padding: 0px;
}
.tablespace .ant-card-head-title {
  font-size: 20px;
  font-weight: 600;
}
.ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px;
}
.ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0;
}
ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li.ant-menu-item-selected
  path {
  color: #fff;
}
.ant-avatar-group .ant-avatar-square {
  border-radius: 4px;
}

.shape-avatar {
  margin-right: 20px;
}

.shape-avatar img {
  border-radius: 4px;
}

.avatar-info h5 {
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 3px;
}

.avatar-info p {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
  margin: 0px;
}

.ant-table-tbody > tr > td h5 {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 0px;
}
.ant-table-tbody > tr > td p {
  font-size: 14px;
  color: #8c8c8c;
  margin: 0px;
}

.tag-primary {
  border-radius: 6px;
  padding: 2px 12px;
  font-size: 14px;
  height: auto;
  line-height: 24px;
  font-weight: 600;
}

.ant-employed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  color: #8c8c8c;
}

.ant-employed a {
  color: #8c8c8c;
  text-decoration: none;
  font-weight: 600;
}

.tag-badge {
  border-radius: 6px;
  padding: 2px 12px;
  font-size: 14px;
  height: auto;
  line-height: 24px;
  font-weight: 600;
  background: #8c8c8c;
  color: #fff;
  outline: none;
}

.tag-badge:hover {
  background: #8c8c8c;
  color: #fff;
  border-color: #8c8c8c;
  opacity: 0.9;
}

.ant-avatar-group {
  align-items: center;
}

.mb-24 {
  margin-bottom: 24px;
}

.ant-table-thead > tr > th {
  color: #8c8c8c;
  font-weight: 700;
  background-color: transparent;
  font-size: 12px;
}

.ant-border-space th:before {
  display: none;
}
.ant-table-tbody > tr > td,
.ant-table-thead > tr > th {
  padding: 16px 25px;
}
.tablespace {
  overflow: hidden;
}
.ant-table.ant-table-middle .ant-table-title,
.ant-table.ant-table-middle .ant-table-footer,
.ant-table.ant-table-middle .ant-table-thead > tr > th,
.ant-table.ant-table-middle .ant-table-tbody > tr > td,
.ant-table.ant-table-middle tfoot > tr > th,
.ant-table.ant-table-middle tfoot > tr > td {
  padding: 16px 25px;
}

.avatar-sm {
  width: 25px;
}

.ant-progress-project {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ant-progress-project .ant-progress-outer {
  float: right;
}

.ant-progress-project .ant-progress-text {
  margin: 0px 0px 0px 0px;
  color: #8c8c8c;
  font-weight: 600;
}
.semibold {
  font-weight: 600;
  color: #8c8c8c;
}

.text-sm {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
}
.ant-progress-project .ant-progress {
  margin-right: 15px;
}

.semibold {
  font-weight: 600;
  color: #8c8c8c;
}

.text-sm {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
}

.ant-progress-project .ant-progress-bg {
  height: 3px !important;
}
.ant-table-tbody > tr > td,
.ant-table-thead > tr > th {
  white-space: nowrap;
}
.h-full {
  height: 100%;
}
@media (min-width: 1200px) {
  .ant-col.col-img img {
    height: 196px;
  }
  /* .bar-chart {
    max-width: 438px;
  } */
  /* .full-width {
    max-width: 658px;
  } */
}
@media (max-width: 1024px) {
  .bar-chart {
    max-width: 100%;
  }
  .full-width {
    max-width: 100%;
  }
  /* .ant-col.mobile-24 {
    margin-bottom: 24px;
  } */
}

body {
  overflow: visible !important;
  width: 100% !important;
}

.card-info-2 .ant-card-body {
  height: 100%;
}

.col-content {
  flex-grow: 1;
  padding: 24px;
  margin-right: 0;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-content p {
  font-size: 16px;
}

.ant-layout-footer {
  padding: 0px 50px;
}
/* sign up start */
.layout-default.ant-layout.layout-sign-up header.ant-layout-header {
  background-color: transparent;
  color: #fff;
  margin: 0;
  padding: 0 20px;
  z-index: 1;
}

.layout-default .ant-layout-header {
  display: flex;
}

.header-col.header-nav {
  margin-left: auto;
  width: 100%;
  margin-right: auto;
}
.header-col.header-nav .ant-menu-overflow {
  justify-content: center;
}

.header-col.header-nav .ant-menu-horizontal {
  background: transparent;
  box-shadow: none;
  border: 0px;
}

.layout-default.ant-layout.layout-sign-up {
  padding: 11px;
}
.header-col.header-nav li:after {
  display: none;
}
.sign-up-header {
  height: 550px;
  margin-top: -62.8px;
  padding-top: 137.8px;
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  background-size: cover;
  background-position: 50%;
  text-align: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center top;
}
.header-col.header-brand {
  white-space: nowrap;
}

.header-col.header-brand h5 {
  margin: 0px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.header-col.header-nav {
  color: #fff;
  font-weight: 600;
}

.header-col.header-nav ul li {
  color: #fff !important;
}

.header-col.header-nav ul li img {
  margin-top: -2px;
  margin-right: 5px;
}
.header-col.header-btn button {
  height: 34px;
  padding: 0 16px;
  border-radius: 34px;
  line-height: 33px;
}
.sign-up-header .content {
  padding-top: 40px;
  max-width: 480px;
  margin: auto;
}
.sign-up-header * {
  color: #fff;
}
.sign-up-header .content h1 {
  font-size: 48px;
  color: #fff;
}
.text-lg {
  font-size: 16px;
}
.card-signup .sign-up-gateways .ant-btn {
  margin-right: 10px;
  margin-left: 10px;
  height: 60px;
  width: 70px;
  box-shadow: none;
  border-radius: 6px;
}
.card-signup {
  width: 100%;
  max-width: 500px;
  margin: auto;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  border-radius: 12px;
  margin-top: -190px;
  margin-bottom: 20px;
}
.card-signup h5 {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #141414;
  margin: 0px;
}
.header-solid .ant-card-head {
  border-bottom: 0;
}
.card-signup .sign-up-gateways .ant-btn img {
  width: 20px;
}
.sign-up-gateways {
  text-align: center;
}
.m-25,
.mb-25,
.my-25 {
  margin-bottom: 25px;
}
.m-25,
.mt-25,
.my-25 {
  margin-top: 25px;
}
.text-center {
  text-align: center;
}
.font-semibold {
  font-weight: 600;
}
.text-muted {
  color: #8c8c8c;
}
.ant-input {
  border-radius: 6px;
}
.ant-input {
  font-weight: 600;
  color: #8c8c8c;
}
.ant-input {
  height: 40px;
  border: 1px solid #d9d9d9;
}
.font-bold {
  font-weight: 700;
}
.text-dark {
  color: #141414;
}
.ant-btn,
.ant-radio-group .ant-radio-button-wrapper {
  font-weight: 600;
  font-size: 12px;
  height: 40px;
  padding: 0 15px;
  line-height: 40px;
}
.ant-btn {
  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);
  border-radius: 6px;
}
.layout-sign-up .ant-layout-footer {
  padding: 24px 50px;
}

.layout-default .ant-layout-footer {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  background: transparent;
  text-align: center;
}
.layout-default .ant-layout-footer .ant-menu-horizontal {
  border: none;
  line-height: 1.5;
  margin: 0 0 30px;
  background-color: transparent;
  font-size: 16px;
}
.layout-default .ant-layout-footer .ant-menu-horizontal {
  text-align: center;
  display: block;
}

.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item,
.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item-active,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-item-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item:hover,
.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-submenu,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu-active,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu-selected,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu:hover {
  color: #8c8c8c;
  border: none;
}
.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item-active,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-item-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item:hover,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu-active,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu-selected,
.layout-default
  .ant-layout-footer
  .ant-menu-horizontal
  > .ant-menu-submenu:hover {
  color: #262626;
}
.layout-default.ant-layout.layout-sign-up .ant-layout-footer ul li:after {
  display: none;
}
.layout-default.ant-layout.layout-sign-up footer.ant-layout-footer ul li a svg {
  width: 18px;
  height: 18px;
}
.layout-default .ant-layout-footer .menu-nav-social a svg {
  fill: #8c8c8c;
  vertical-align: middle;
}
.layout-default .ant-layout-footer .menu-nav-social a:hover svg {
  fill: #1890ff;
}
.layout-default .ant-layout-footer .copyright a {
  color: inherit;
  font-weight: normal;
}
/* signin start csss */
.layout-default.layout-signin header.ant-layout-header {
  display: flex;
  position: relative;
  background-color: #fff;
  color: #141414;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  flex-direction: row;
  padding: 0 50px;
  height: 64px;
  line-height: 64px;
}
.fill-muted {
  fill: #8c8c8c;
}
.layout-default .ant-layout-header .header-brand h5 {
  white-space: nowrap;

  color: #141414;
  margin: 0;
}
.layout-default .ant-layout-header .header-nav a svg {
  margin-right: 5px;
}
.layout-default .ant-layout-header .header-nav a span,
.layout-default .ant-layout-header .header-nav a svg {
  vertical-align: middle;
}
.layout-default .ant-layout-header .header-nav a {
  color: #141414;
  padding: 6px 12px;
  font-weight: 400;
}

.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-item,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-item-active,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-item-selected,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-item:hover,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-submenu,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-submenu-active,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-submenu-selected,
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-submenu:hover {
  color: #8c8c8c;
  font-weight: 600;
  border: none;
}
.layout-default
  .ant-layout-header
  .header-nav
  .ant-menu-horizontal
  > .ant-menu-item {
  padding: 0;
}
.sign-in {
  padding: 0 20px;
}
.layout-default .ant-layout-content {
  padding-top: 40px;
}
.font-regular {
  font-weight: 400;
}
.signin h1 {
  font-size: 48px;
  font-weight: 700;
  color: #141414;
}

.signin h5 {
  font-weight: 400;
  color: #8c8c8c;
  font-size: 20px;
  white-space: normal;
}
.ant-row.ant-form-item.username {
  display: block;
}

.ant-row.ant-form-item.username
  .ant-col.ant-form-item-label
  .ant-form-item-required:before {
  display: none;
}

.ant-row.ant-form-item.username .ant-col.ant-form-item-label {
  font-size: 13px;
  font-weight: 600;
  color: #141414;
}
.signin .ant-form-item-control-input button.ant-switch {
  margin-right: 5px;
}
.text-dark {
  color: #141414;
}
.sign-img img {
  width: 100%;
  max-width: 500px;
  margin: auto;
  display: block;
}
.layout-signin {
  background: #fff;
}
.layout-signin footer.ant-layout-footer svg {
  width: 18px;
  height: 18px;
}

.layout-signin footer.ant-layout-footer ul li:after {
  display: none;
}
.layout-default .ant-layout-footer .copyright {
  font-size: 16px;
  color: #8c8c8c;
}

.row-col .ant-row {
  margin-left: 0px;
  margin-right: 0px;
}
.layout-default.ant-layout.layout-sign-up .header-col.header-brand h5 {
  color: #fff;
}

.layout-default.ant-layout.layout-sign-up .header-col.header-nav a {
  color: #fff;
}

.layout-default.ant-layout.layout-sign-up
  .header-col.header-nav
  svg
  path.fill-muted {
  fill: #fff;
}
/* sign in end */

@media (min-width: 768px) {
  .sign-img img {
    margin: 0;
  }
  .card-signup {
    margin-bottom: 120px;
  }
  .card-signup .sign-up-gateways .ant-btn {
    width: 100px;
  }
}

/* end sign up */

.rightside-top .signin {
  display: inline-flex;
}

.rightside-top .signin svg {
  margin-right: 5px;
}

button.ant-btn.bell strong {
  position: absolute;
  top: -1px;
  right: -9px;
  display: inline-block;
  width: 18px;
  height: 18px;
  background: #f5222d;
  border-radius: 100%;
  text-align: center;
  line-height: normal;
  font-weight: normal;
  color: #fff;
}
/* old css end */

.layout-dashboard .ant-layout-footer {
  background: transparent;
  margin: 0 20px 20px 20px;
  padding: 0;
}

.layout-dashboard .ant-layout-content {
  padding: 0;
  margin: 0 20px 0;
}
.m-10,
.mr-10,
.mx-10 {
  margin-right: 10px !important;
}

.ant-table-tbody > tr > td h6 {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
}

.layout-dashboard .header-control .header-search input.ant-input {
  height: auto;
}

small.redtext {
  color: red;
}

.full-width path {
  fill: transparent;
}

.bar-chart line.apexcharts-xaxis-tick {
  stroke: transparent;
}

section.ant-layout.layout-content .ant-layout-content.content-ant {
  padding: 0px !important;
}

.layout-dashboard .ant-card {
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
}

.card-credit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 50%;
  background-size: cover;
  border: none;
}
.card-credit * {
  color: #fff;
}

.card-credit .card-number {
  word-spacing: 10px;
  font-weight: 600;
  margin-bottom: 45px;
  font-size: 20px;
}
.ant-card-head-wrapper {
  min-height: 72px;
}
.card-credit .ant-card-body {
  padding-top: 15px;
}
.card-credit .card-footer {
  display: flex;
  align-items: flex-end;
}
.m-auto,
.ml-auto {
  margin-left: auto !important;
}
.m-30,
.mr-30,
.mx-30 {
  margin-right: 30px !important;
}
.card-credit .card-footer h6,
.card-credit .card-footer p {
  margin-bottom: 0;
}
.card-credit .col-logo img {
  max-width: 50px;
}
.card-credit .card-footer h6 {
  font-weight: 700;
}
.width-100 {
  width: 100%;
}
.p-20 {
  padding: "0px 20px 0px 0px";
}
.layout-default .ant-layout-content.p-0 {
  padding: 0px;
}
.pt {
  padding-top: 0px;
}

.widget-2 .icon {
  width: 64px;
  height: 64px;
  margin: auto;
  background-color: #1890ff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
.widget-2 .ant-statistic-title h6 {
  font-weight: 600;
}
.widget-2 .ant-statistic-title p {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0;
}
.widget-2 .ant-statistic-content {
  font-family: open sans, Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 20px;
  padding: 12px 16px;
  border-top: 1px solid #f5f5f5;
  text-align: center;
}
.widget-2 .ant-statistic-title {
  text-align: center;
  padding: 16px;
}

.widget-2 .ant-card-body {
  padding: 0;
}
.widget-2 .icon img {
  width: 30px;
}

.ant-row-flex-middle {
  align-items: center;
}
.d-flex {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.payment-method-card.ant-card {
  box-shadow: none;
  word-spacing: 10px;
}

.payment-method-card.ant-card img {
  width: 40px;
}
.payment-method-card.ant-card .ant-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.payment-method-card.ant-card .ant-btn {
  margin-right: -20px;
}

.ant-btn.ant-btn-link.ant-edit-link {
  font-weight: 600;
  font-size: 12px;
  height: 40px;
  padding: 0 15px;
  box-shadow: none;
}

.ant-btn.ant-btn-link.ant-edit-link img {
  width: 20px;
}
.payment-method-card.ant-card .ant-btn {
  margin-right: -20px;
}

.fill-gray-7 {
  fill: #8c8c8c !important;
}

.payment-method-card.ant-card h6 {
  font-weight: 600;
  margin-bottom: 0;
  color: #141414;
}
.m-0 {
  margin: 0px;
}

.ant-card.ant-card-bordered.payment-method-card .ant-card-body {
  padding-top: 16px;
}

.header-solid .ant-card-head {
  border-bottom: 0;
}
.invoice-list .ant-list-item,
.transactions-list .ant-list-item {
  padding: 11px 0;
  border-bottom: 0;
}
.ant-invoice-card .ant-card-body {
  padding-top: 0px;
}
.invoice-list .ant-list-item-meta-title,
.transactions-list .ant-list-item-meta-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
}

.invoice-list .ant-list-item-meta-description,
.transactions-list .ant-list-item-meta-description {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
}

.invoice-list .ant-list-item-action .ant-btn,
.transactions-list .ant-list-item-action .ant-btn {
  font-weight: 600;
  color: #141414;
  box-shadow: none;
}

.ant-btn > svg,
.ant-btn > svg + span {
  vertical-align: middle;
}
.invoice-list .amount,
.transactions-list .amount {
  font-size: 14px;
  font-weight: 600;
  color: #8c8c8c;
}

.card-billing-info.ant-card {
  box-shadow: none;
  background-color: #fafafa;
  border: 1px solid #f5f5f5;
}

.ant-descriptions .ant-descriptions-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 14px;
}

.fill-danger {
  fill: #ff4d4f;
}
.card-billing-info.ant-card .darkbtn {
  color: #8c8c8c;
}

.col-action {
  display: flex;
}

.card-billing-info .col-action button {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
  box-shadow: none;
}

.ant-descriptions .ant-descriptions-row > td,
.ant-descriptions .ant-descriptions-row > th {
  padding-bottom: 6px;
}

.ant-descriptions .ant-descriptions-item-label {
  font-size: 13px;
  font-weight: 600;
  color: #8c8c8c;
}

.ant-descriptions .ant-descriptions-item-content {
  font-size: 13px;
  font-weight: 600;
  color: #141414;
}

.ant-descriptions .ant-descriptions-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 14px;
}

.card-billing-info.ant-card .ant-descriptions-header {
  margin-bottom: 0px;
}

.card-header-date {
  margin-bottom: 0;
  font-weight: 700;
  color: #8c8c8c;
}

.card-header-date > * {
  vertical-align: middle;
}
.card-header-date svg {
  margin-right: 5px;
}

.transactions-list .amount {
  font-size: 16px;
  font-weight: 700;
}

.text-light-danger {
  background: #fde3cf;
  color: #f56a00;
}
.text-fill {
  color: #52c41a;
  background: #edf9e7;
}
.text-danger {
  color: #f5222d;
}
.text-success {
  color: #52c41a;
}

.transactions-list .ant-list-item-meta {
  align-items: center;
}

.text-warning {
  background: rgb(255, 252, 231);
  color: #fadb14;
}
.text-warning-b {
  font-size: 14px;
  font-weight: 600;
  color: #fadb14;
}
.ant-card.ant-list-yes .ant-list-header {
  border: 0px;
}

.ant-card.ant-list-yes .ant-list-header h6 {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  margin: 6px 0;
}

.ant-list.ant-list-split.transactions-list.ant-newest .ant-list-header {
  padding-top: 0px;
}
.profile-nav-bg {
  height: 300px;
  margin-top: -137.8px;
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  background-size: cover;
  background-position: 50%;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  span.ant-page-header-heading-title {
  color: #fff;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  span.ant-breadcrumb-separator {
  color: #fff;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  span.ant-breadcrumb-link {
  color: #fff;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  .header-control
  svg
  path {
  fill: #fff;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  .btn-sign-in {
  color: #fff;
}

.layout-profile .ant-layout-header {
  margin: 10px 20px;
}
.card-profile-head .ant-card-head {
  border-bottom: 0px;
  padding: 0px 16px;
}

.card-profile-head {
  margin: -53px 0 24px;
}

.card-profile-head .ant-card-head .ant-avatar {
  box-shadow: 0 5px 10px rgb(0 0 0 / 12%);
  border-radius: 8px;
  margin: 0;
}

.card-profile-head .ant-card-head .avatar-info {
  margin-left: 16px;
}

.ant-card-head-title p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 0;
}

.card-profile-head .ant-card-head .avatar-info h4 {
  font-size: 24px;
}

.card-profile-head .ant-card-head .avatar-info h4 {
  font-size: 24px;
}

.card-profile-head .ant-radio-group .ant-radio-button-wrapper {
  height: auto;
  font-weight: 700;
}
.ant-radio-button-wrapper {
  color: #595959;
}

.layout-profile .ant-card-head {
  padding: 0 16px;
}

.settings-list {
  list-style: none;
  padding: 0;
}
.settings-list > li:first-child {
  padding-top: 0;
}
.settings-list > li {
  padding: 12px 0;
}

.settings-list > li h6 {
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
  font-weight: 700;
}
.settings-list > li span {
  margin-left: 16px;
  color: #141414;
}
.ant-btn-link {
  box-shadow: none;
}
.card-profile-information hr {
  opacity: 0.2;
}

.p-5,
.pr-5,
.px-5 {
  padding-right: 5px !important;
}
.p-5,
.pl-5,
.px-5 {
  padding-left: 5px !important;
}
.m-5,
.mr-5,
.mx-5 {
  margin-right: 5px !important;
}
.m-5,
.ml-5,
.mx-5 {
  margin-left: 5px !important;
}

.card-profile-information .ant-descriptions .ant-descriptions-row > td,
.card-profile-information .ant-descriptions .ant-descriptions-row > th {
  padding-bottom: 16px;
}

.conversations-list .ant-list-item-meta-description {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
}

.conversations-list .ant-avatar {
  border-radius: 10.5px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
}
.conversations-list .ant-list-item {
  padding: 14px 0;
}

.ant-card-head-title p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 0;
}

.ant-card-head-title h6 {
  margin-bottom: 0;
}

.card-project.ant-card {
  box-shadow: none;
  border: none;
}

.card-project.ant-card .ant-card-cover img {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
}

.card-project.ant-card .card-tag,
.card-project.ant-card p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 5px;
}
.card-project.ant-card h5 {
  font-weight: 600;
  font-size: 20px;
}
.card-project.ant-card .card-tag,
.card-project.ant-card p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 5px;
}
.card-project.ant-card p {
  margin-bottom: 0;
}
.card-project.ant-card .ant-card-body {
  padding: 16px 0 0;
}

.card-project.ant-card .card-footer {
  margin-top: 22px;
}

.avatar-chips .ant-avatar-image {
  border: 1px solid #fff;
}
.avatar-chips .ant-avatar-image:hover,
.avatar-chips .ant-space-item:hover {
  z-index: 1;
}

.projects-uploader {
  height: 100%;
  border-radius: 8px;
  border-color: #d9d9d9;
}
.projects-uploader .ant-upload {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
  padding: 8px;
}

.projects-uploader .ant-upload-list.ant-upload-list-picture-card {
  height: 100%;
}

.projects-uploader .ant-upload.ant-upload-select-picture-card {
  background-color: transparent;
}

.projects-uploader svg {
  width: 20px;
  height: 20px;
}

.text-right {
  text-align: right;
}

.layout-dashboard-rtl {
  background: transparent;
  text-align: right;
  direction: rtl;
  position: relative;
  overflow-x: hidden;
}

.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-item .icon,
.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-submenu .icon {
  margin-left: 11px;
  margin-right: 0;
}

.layout-dashboard-rtl .ant-timeline-item-tail {
  right: 6.5px;
  left: auto;
}
.layout-dashboard-rtl .ant-timeline-item-content {
  margin: 0 33px 0 0;
}

.ant-timeline-item-head {
  width: 15px;
  height: 15px;
  border-width: 3px;
}

.layout-dashboard-rtl .ant-radio-button-wrapper:first-child {
  border-right-width: 1px;
  border-radius: 0 4px 4px 0;
}
.layout-dashboard-rtl .ant-list-box td {
  text-align: right;
}

.layout-dashboard-rtl .ant-space-horizontal {
  direction: ltr;
}

.layout-dashboard-rtl .ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-right: 8px;
  margin-left: 0px;
}
.layout-dashboard-rtl .setting-drwer {
  left: 30px;
  right: auto;
}

.layout-dashboard-rtl ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light {
  text-align: right;
}

.layout-dashboard-rtl .avatar-group.mt-2 {
  direction: ltr;
}
.ant-list-box table tr:hover td {
  background: #fafafa;
}
.layout-dashboard-rtl .icon-box {
  margin-left: 0px;
  margin-right: auto;
}
.layout-dashboard-rtl .m-10,
.layout-dashboard-rtl .mr-10,
.layout-dashboard-rtl .mx-10 {
  margin-left: 10px !important;
}

.layout-dashboard-rtl .ant-progress-show-info .ant-progress-outer {
  margin-right: 0px;
  padding-right: 0px;
}

.layout-dashboard-rtl .ant-badge-count,
.layout-dashboard-rtl .ant-badge-dot,
.layout-dashboard-rtl .ant-badge .ant-scroll-number-custom-component {
  left: 0;
  right: auto;
  transform: translate(-50%, -50%);
}

.layout-dashboard-rtl .header-control .btn-sign-in svg {
  margin-left: 4px;
  margin-right: 0px;
}

.ant-drawer.drawer-sidebar.drawer-sidebar-rtl
  aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {
  left: auto;
  right: 0px;
  direction: rtl;
}

.layout-dashboard.layout-dashboard-rtl .header-control span.ant-badge {
  margin: 0px 7px;
}

.layout-dashboard.layout-dashboard-rtl span.ant-input-prefix {
  margin-right: 0px;
  margin-left: 4px;
}

.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl button.ant-drawer-close {
  left: 0px;
  right: auto;
  margin-right: 0px;
  margin-left: var(--scroll-bar);
  padding-left: calc(20px - var(--scroll-bar));
}

.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl button.ant-drawer-close {
  left: 0px;
  right: auto;
  margin-right: 0px;
  margin-left: var(--scroll-bar);
  padding-left: calc(20px - var(--scroll-bar));
}

.settings-drawer.settings-drawer-rtl .sidebarnav-color button {
  margin-right: 0px;
  margin-left: 10px;
}

.settings-drawer.settings-drawer-rtl .viewstar a:first-child {
  border-radius: 0em 0.25em 0.25em 0;
  border-right: 1px solid #ddddde;
}

.settings-drawer.settings-drawer-rtl .viewstar a {
  border-radius: 0.25em 0 0 0.25em;
  border: 1px solid #ddddde;
  border-right: 0px;
}

.social svg path {
  fill: #fff;
}

.settings-drawer.settings-drawer-rtl .social svg {
  margin-right: 0px;
  margin-left: 5px;
}

.social svg {
  width: 15px;
  height: 15px;
}

.layout-dashboard .ant-affix .ant-layout-header {
  background: #fff;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  margin: 10px 20px;
  z-index: 10;
}

aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.active-route
  a.active {
  background: transparent;
  box-shadow: none;
}
.uploadfile.pb-15 {
  padding-bottom: 16px;
}

.ant-row.ant-form-item.aligin-center .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

.uploadfile.shadow-none
  .ant-upload.ant-upload-select.ant-upload-select-text
  .ant-btn.ant-full-box {
  box-shadow: none;
}

.ant-btn-dashed {
  color: rgba(0, 0, 0, 0.65);
}
button.ant-btn.ant-btn-dashed.ant-full-box svg {
  width: 16px;
  height: 16px;
}

.ant-btn-dashed.active,
.ant-btn-dashed:active {
  color: #096dd9;
  background-color: #fff;
  border-color: #096dd9;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile
  .header-control
  span.ant-input-affix-wrapper.header-search
  .anticon-search
  svg
  path {
  fill: #8c8c8c;
}


/* Profits page */
.profits-page .ant-card {
  border-radius: 8px;
  box-shadow: 0 8px 24px rgb(0 0 0 / 4%);
}

.profits-page .profit-hero .ant-card-body {
  padding: 24px;
}

.profits-page .profit-hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}

.profits-page .profit-account {
  display: flex;
  gap: 14px;
  align-items: center;
  min-width: 0;
}

.profits-page .profit-account-icon {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e6f7ff;
  color: #1890ff;
  font-size: 22px;
  flex: 0 0 auto;
}

.profits-page .profit-account-title {
  margin: 0;
  color: #141414;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.profits-page .profit-account-subtitle {
  color: #8c8c8c;
  margin-top: 4px;
}

.profits-page .profit-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.profits-page .profit-overview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}

.profits-page .profit-overview-item {
  min-height: 86px;
  padding: 16px 18px;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.profits-page .profit-overview-item:nth-child(3n) {
  border-right: 0;
}

.profits-page .profit-overview-item:nth-child(n + 4) {
  border-bottom: 0;
}

.profits-page .profit-overview-label {
  color: #8c8c8c;
  font-size: 13px;
  margin-bottom: 8px;
}

.profits-page .profit-overview-value {
  color: #141414;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  word-break: keep-all;
}

.profits-page .profit-toolbar {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.profits-page .profit-filter-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.profits-page .profit-chart-range {
  display: flex;
  justify-content: space-between;
  color: #8c8c8c;
  font-size: 14px;
  margin-top: 4px;
}

.profits-page .profit-table-card .ant-card-body {
  padding: 0;
}

.profits-page .profit-table-card .ant-card-head {
  border-bottom: 1px solid #f0f0f0;
}

@media (max-width: 768px) {
  .profits-page .profit-hero-top {
    flex-direction: column;
  }

  .profits-page .profit-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .profits-page .profit-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .profits-page .profit-overview-item,
  .profits-page .profit-overview-item:nth-child(3n) {
    border-right: 1px solid #f0f0f0;
  }

  .profits-page .profit-overview-item:nth-child(2n) {
    border-right: 0;
  }

  .profits-page .profit-overview-item:nth-child(n + 4) {
    border-bottom: 1px solid #f0f0f0;
  }

  .profits-page .profit-overview-item:nth-child(n + 5) {
    border-bottom: 0;
  }

  .profits-page .profit-overview-value {
    font-size: 18px;
  }

  .profits-page .profit-filter-row,
  .profits-page .profit-filter-row .ant-picker,
  .profits-page .profit-filter-row .ant-input,
  .profits-page .profit-filter-row .ant-btn {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;;;;;;;;;;CAUC;AACD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;AACtD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,OAAO;EACP,WAAW;EACX,aAAa;EACb,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;EAUE,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;EAgBE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;;;EAME,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;;;;;GAKC;EACD,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE;;;wBAGsB;;EAEtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;mDACiD;AACnD;AACA;;;EAGE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;;EAEX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;GAGG;;AAEH;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,wEAAiE;EACjE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,+DAA+D;EAC/D,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;;EAGE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;;KAEG;EACH;;KAEG;AACL;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;KAEG;AACL;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,wEAA+D;AACjE;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,cAAc;EACd,YAAY;AACd;AACA;;;;;;;;;;;;;;;;;;EAkBE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;;EAEnB,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;;;;EAKE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,UAAU;AACZ;AACA,gBAAgB;;AAEhB;EACE;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;AACF;;AAEA,gBAAgB;;AAEhB;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,yDAAkD;EAClD,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;;EAEE,4BAA4B;AAC9B;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,OAAO;EACP,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;;;;EAME,aAAa;AACf;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,sBAAsB;EACxB;AACF","sourcesContent":["/*!\n=========================================================\n* Muse Ant Design Dashboard - v1.0.0\n=========================================================\n* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard\n* Copyright 2021 Creative Tim (https://www.creative-tim.com)\n* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)\n* Coded by Creative Tim\n=========================================================\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n*/\nbody {\n  padding: 0 0 30px 0;\n  background-color: #fafafa;\n  letter-spacing: -0.3px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 1.6;\n  font-weight: 400;\n  font-family: open sans, Helvetica, Arial, sans-serif;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n}\n.layout-dashboard {\n  background: transparent;\n  text-align: left;\n  position: relative;\n  overflow-x: hidden;\n}\n@media (min-width: 992px) {\n  .layout-dashboard {\n    overflow: auto;\n  }\n}\n.layout-dashboard .ant-layout-sider.sider-primary {\n  width: 250px;\n  position: fixed;\n  left: 0;\n  z-index: 99;\n  height: 100vh;\n  overflow: auto;\n  margin: 0;\n  padding: 33px 20px;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .brand img {\n  height: 30px;\n}\n.layout-dashboard .ant-layout-sider.sider-primary hr {\n  margin: 18px 0;\n  border: none;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .brand {\n  font-weight: 600;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .brand span {\n  vertical-align: middle;\n  margin-left: 3px;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {\n  width: auto;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline {\n  border: none;\n}\n.layout-dashboard .ant-menu {\n  background: transparent;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-inline\n  .ant-menu-item,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-inline\n  .ant-menu-submenu {\n  margin: 0;\n  overflow: visible;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu {\n  padding: 0 !important;\n  height: auto;\n  line-height: normal;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-inline\n  .ant-menu-item:after,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-inline\n  .ant-menu-submenu:after {\n  display: none;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-item-selected,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-item:active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item\n  .ant-menu-submenu-selected,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-submenu-title:active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item\n  .ant-menu-submenu:active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-item-selected,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-item:active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu\n  .ant-menu-submenu-selected,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-submenu-title:active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu\n  .ant-menu-submenu:active {\n  background-color: transparent;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-item-selected\n  .active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-item-selected\n  .active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active {\n  background-color: #fff;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  font-weight: 600;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a {\n  padding: 10px 16px;\n  color: #141414;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .ant-menu-item.ant-menu-item-selected\n  .active\n  .icon,\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .ant-menu-item\n  .active\n  .icon {\n  background-color: #1890ff;\n}\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-item-selected\n  .active\n  .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-item-selected\n  .active\n  .icon,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu\n  .active\n  .icon {\n  background-color: #1890ff;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .icon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  background-color: #fff;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  margin-right: 11px;\n  vertical-align: middle;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item.ant-menu-item-selected\n  .active\n  svg\n  path,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-item\n  .active\n  svg\n  path,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu.ant-menu-item-selected\n  .active\n  svg\n  path,\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-submenu\n  .active\n  svg\n  path {\n  fill: #fff;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item svg path,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu svg path {\n  fill: #bfbfbf;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a:hover,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a:hover {\n  color: #141414;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary\n  .ant-menu-inline\n  .ant-menu-item.menu-item-header {\n  padding: 10px 16px !important;\n  color: #8c8c8c;\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n  display: block;\n}\n\n.menu-item-header:hover {\n  color: inherit;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-zero-width {\n  overflow-x: hidden;\n  width: 210px;\n  margin: 0;\n  padding: 33px 0;\n}\n\n.layout-dashboard.has-sidebar .ant-layout-sider.sider-primary .aside-footer {\n  display: block;\n}\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .footer-box {\n  background-color: #1890ff;\n  color: #fff;\n  box-shadow: none;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box {\n  background-color: #fff;\n  color: #141414;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  margin-bottom: 8px;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .footer-box\n  .icon {\n  background-color: #fff;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box .icon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 15px;\n  background-color: #1890ff;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .footer-box\n  h6 {\n  color: #fff;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box h6 {\n  font-weight: 600;\n  font-size: 16px;\n  color: #141414;\n  margin-bottom: 0;\n}\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .footer-box\n  p {\n  color: #f5f5f5;\n}\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box p {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.layout-dashboard\n  .ant-layout-sider.sider-primary.ant-layout-sider-primary\n  .footer-box\n  button {\n  background-color: #fff;\n  border-color: #f0f0f0;\n  color: #141414;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box button {\n  margin: 0;\n}\n.ant-btn-sm,\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n}\n.ant-btn-sm {\n  border-radius: 4px;\n}\n\n.ant-btn-sm,\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n}\n.ant-btn-sm {\n  border-radius: 4px;\n}\n.ant-btn,\n.ant-radio-group .ant-radio-button-wrapper {\n  font-weight: 600;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .aside-footer {\n  padding-top: 100px;\n  padding-bottom: 33px;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {\n  display: block;\n}\n\n.ant-layout.ant-layout-has-sider > .ant-layout,\n.ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: hidden;\n}\n.layout-dashboard .ant-layout {\n  background: transparent;\n  position: relative;\n  min-height: 100vh;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.layout-dashboard .ant-layout-header {\n  background: transparent;\n  height: auto;\n  padding: 16px;\n  margin: 10px 4px;\n  line-height: inherit;\n  border-radius: 12px;\n  transition: 0.2s;\n}\n\n.layout-dashboard .ant-breadcrumb > span .ant-breadcrumb-link a {\n  color: #8c8c8c;\n}\n.layout-dashboard .ant-breadcrumb > span:last-child .ant-breadcrumb-link {\n  color: #141414;\n}\n.layout-dashboard .ant-page-header-heading {\n  margin-top: 0;\n}\n.layout-dashboard .ant-page-header-heading .ant-page-header-heading-title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: 4px;\n}\n.layout-dashboard .header-control {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown {\n  background: #fff;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  border-radius: 12px;\n  min-width: 276px;\n  padding: 16px 8px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  ul.ant-dropdown-menu-items {\n  margin: 0px;\n  padding: 0px;\n}\n\n.ant-dropdown.ant-dropdown-placement-bottomRight {\n  min-width: inherit !important;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-list-item {\n  padding: 5px 16px;\n  margin-bottom: 8px;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-avatar {\n  width: 36px;\n  height: 36px;\n  background-color: #fafafa;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-list-item-meta-title {\n  line-height: normal;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdownt\n  .ant-list-item-meta-description {\n  color: #8c8c8c;\n  font-size: 12px;\n  line-height: 12px;\n  font-weight: 600;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-list-item-meta-description\n  svg {\n  width: 14px;\n  height: 14px;\n  fill: #8c8c8c;\n  vertical-align: middle;\n  margin-right: 4px;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-list-item-meta-description\n  svg\n  path {\n  fill: #8c8c8c;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-list-item-meta-description\n  span {\n  vertical-align: middle;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-avatar\n  .ant-avatar-string {\n  top: 6px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown\n  .ant-avatar\n  .ant-avatar-string\n  svg {\n  width: 22px;\n  height: 22px;\n}\n\n.h3,\n.h4,\nh3,\nh4 {\n  font-weight: 700;\n  color: #141414;\n}\n\n.ant-list-item-meta-title > a {\n  color: rgba(0, 0, 0, 0.65);\n  transition: all 0.3s;\n}\n\n.ant-list-item-meta-title {\n  margin-bottom: 4px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.layout-dashboard .header-control .ant-btn-link {\n  height: auto;\n  padding: 0 7px;\n  margin: 0;\n  box-shadow: none;\n  color: #8c8c8c;\n  line-height: normal;\n}\n\n.ant-btn svg {\n  margin-right: 5px;\n}\n.layout-dashboard .header-control svg {\n  width: 20px;\n  height: 20px;\n}\n\n.layout-dashboard .header-control svg path {\n  fill: #141414;\n}\n\n.layout-dashboard .header-control .btn-sign-in {\n  height: auto;\n  padding: 0 7px;\n  margin: 0;\n  box-shadow: none;\n  color: #8c8c8c;\n}\n.layout-dashboard .header-control .btn-sign-in svg {\n  margin-right: 4px;\n}\n.layout-dashboard .header-control svg {\n  vertical-align: middle;\n}\n\n.layout-dashboard .header-control .header-search {\n  width: 213px;\n  margin: 0 7px 0 0;\n  border-radius: 6px;\n  height: 40px;\n  border: 1px solid #d9d9d9;\n}\n\n.layout-dashboard .header-control .anticon.anticon-search svg {\n  width: 16px;\n  height: 16px;\n}\n.layout-dashboard .header-control .header-search svg path {\n  fill: #8c8c8c;\n}\n\n.settings-drawer .drawer-content > hr {\n  margin: 18px 0;\n  border: none;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n\n.settings-drawer .drawer-content > h6 {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.layout-dashboard .settings-drawer .drawer-content h6 {\n  font-weight: 600;\n  color: #141414;\n}\n.settings-drawer .drawer-content p {\n  color: #8c8c8c;\n}\np {\n  font-size: 14px;\n}\n.settings-drawer .drawer-content .sidebar-color h6 {\n  margin-bottom: 8px;\n}\n\n.h6,\nh6 {\n  font-size: 16px;\n}\n\n.drawer-sidebar .ant-drawer-body {\n  padding: 0px;\n}\n\n.drawer-sidebar\n  .ant-drawer-body\n  aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {\n  margin: 0px;\n}\n\n.layout-dashboard\n  .header-control\n  .header-search\n  .ant-input-suffix\n  .ant-input-search-icon.anticon-loading,\n.layout-dashboard .header-control .sidebar-toggler {\n  display: block;\n}\n.layout-dashboard .header-control .btn-sign-in span {\n  font-weight: 600;\n  vertical-align: middle;\n  display: none;\n}\n\n/* Old css start */\n.site-layout-background {\n  background: transparent;\n}\n\nheader.ant-layout-header.subheader {\n  background: transparent;\n}\n\n.sidemenu {\n  margin-top: 20px;\n  margin-left: 20px;\n}\n\n.logo img {\n  width: 32px;\n  margin-right: 10px;\n}\n\n.logo {\n  margin-bottom: 15px;\n}\n.logo span {\n  font-size: 16px;\n  font-weight: 600;\n}\n\nhr.horizontal.dark {\n  background-image: linear-gradient(\n    90deg,\n    transparent,\n    rgb(0 0 0 / 12%),\n    transparent\n  );\n  border: 0px;\n}\nhr.horizontal {\n  background-color: transparent;\n}\nhr:not([size]) {\n  height: 1px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav {\n  background: transparent;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li {\n  padding: 10px 16px !important;\n  height: auto;\n  line-height: normal;\n  margin: 0px;\n  border: 0px;\n  font-size: 16px;\n  color: #141414;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li.ant-menu-item-selected {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li.ant-menu-item-selected {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,\n.ant-menu-inline.ant-menu-root\n  .ant-menu-submenu-title\n  > .ant-menu-title-content {\n  flex: auto;\n  min-width: 0;\n  overflow: visible;\n  text-overflow: ellipsis;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li::after {\n  display: none;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li\n  span.anticon {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  background: #fff;\n  box-shadow: 0px 4px 6px #0000001f;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li.ant-menu-item-selected\n  span.anticon {\n  background: #1890ff;\n  color: #fff;\n}\n\n/* ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:hover {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li:hover\n  span.anticon {\n  background: #1890ff;\n  color: #fff;\n} */\n\n.divder {\n  display: table;\n  width: 100%;\n  padding: 10px 15px;\n  color: #8c8c8c;\n  font-weight: 600;\n  margin: 15px 0px;\n}\n\n.ant-card.ant-card-bordered.documentation-card {\n  border: 0px;\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n}\n.p-15 {\n  padding: 15px;\n}\n.card-document {\n  width: 32px;\n  height: 32px;\n  text-align: center;\n  box-shadow: 0px 4px 6px #0000001f;\n  border-radius: 6px;\n  font-size: 19px;\n  background: #1890ff;\n  color: #fff;\n  direction: ltr;\n  margin-bottom: 15px;\n}\n.documentation-card h4 {\n  margin: 0px;\n}\n.left-nav {\n  /* height: 435px;\n  overflow: hidden;\n  overflow-y: auto;\n  padding-right: 15px; */\n\n  margin-top: 15px;\n}\n.ant-layout {\n  background: #fafafa;\n}\n.pageheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.rightside-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: normal;\n}\n\n.signin {\n  white-space: nowrap;\n  margin: 0px 20px;\n}\n\n.signin span.ant-avatar {\n  margin-right: 9px;\n}\n\n.shadow-lg {\n  box-shadow: 0 8px 26px -4px hsla(0, 0%, 8%, 0.15),\n    0 8px 9px -5px hsla(0, 0%, 8%, 0.06) !important;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border: 0px;\n}\n.header-top h4 {\n  margin: 0px;\n  font-size: 20px;\n}\n\n.header-top .subtitle {\n  display: block;\n  font-weight: normal;\n  color: #8c8c8c;\n  font-size: 14px;\n}\n\n.header-top {\n  margin-top: -10px;\n}\n\n.ant-drawer.ant-drawer-right.ant-drawer-open.colorside button.ant-drawer-close {\n  color: #000;\n}\n.header-top {\n  border-bottom: 1px solid rgb(140 140 140 / 7%);\n  padding-bottom: 15px;\n}\n\n.rightside-top span.ant-input-affix-wrapper {\n  border-radius: 4px;\n}\n\n.rightside-top span.ant-input-affix-wrapper span.ant-input-prefix {\n  color: #c0c0c0;\n}\n\n.setting button.ant-btn {\n  padding: 0px;\n  line-height: normal;\n  background: transparent;\n  border: 0px;\n  box-shadow: none;\n}\nbutton.ant-btn.bell {\n  padding: 0px;\n  border: 0px;\n  background: transparent;\n  box-shadow: none;\n  position: relative;\n}\nbutton.ant-btn.bell strong {\n  position: absolute;\n  top: -1px;\n  right: -5px;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: #f5222d;\n  border-radius: 100%;\n  text-align: center;\n  line-height: normal;\n  font-weight: normal;\n  color: #fff;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {\n  width: 336px;\n}\n\n.list-notifaction ul {\n  padding: 5px 10px;\n  margin: 0px;\n}\n\n.list-notifaction ul li {\n  display: block;\n  width: 100%;\n\n  clear: both;\n  font-weight: 400;\n  color: #67748e;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.list-notifaction ul li a {\n  display: block;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.list-notifaction ul li a:hover {\n  color: #252f40;\n  background-color: #e9ecef;\n}\n\n.list-notifaction ul span.ant-avatar.ant-avatar-image {\n  width: 48px;\n  height: 48px;\n  border-radius: 0.75rem;\n}\n\n.list-notifaction ul li {\n  padding: 0px;\n}\n.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {\n  border-radius: 0.75rem;\n}\n.list-notifaction .ant-list-item-meta-title {\n  font-weight: bold;\n  color: #141414;\n}\n.list-notifaction .ant-list-item-meta-title {\n  font-weight: bold;\n  color: #141414;\n}\n\n.list-notifaction .ant-avatar.ant-avatar-circle {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.list-notifaction ul li a span.ant-avatar-string {\n  line-height: normal;\n}\n.bnb2 {\n  color: #52c41a;\n  font-weight: 700;\n}\n.ant-card.criclebox {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 12px;\n}\n\n.number span {\n  font-weight: 600;\n  color: #8c8c8c;\n  font-size: 14px;\n}\n.number h3 {\n  font-weight: 700;\n  margin-bottom: 0px;\n  font-size: 30px;\n}\n\n.number h3 small {\n  font-weight: 600;\n  font-size: 14px;\n}\n.icon-box {\n  width: 48px;\n  height: 48px;\n  text-align: center;\n  background: #1890ff;\n  color: #fff;\n  border-radius: 0.5rem;\n  margin-left: auto;\n  line-height: 55px;\n}\n\n.icon-box span {\n  color: #fff;\n  font-size: 24px;\n}\n\n.listpage {\n  padding-top: 15px;\n}\n.bar-chart {\n  background: #f8f9fa;\n  box-shadow: 0px 4px 6px #0000001f;\n  border-radius: 8px;\n}\n\n.chart-vistior {\n  margin-top: 30px;\n}\n\n.chart-vistior h5 {\n  margin: 0px;\n  font-weight: 700;\n}\n.ant-typography.lastweek {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.chart-visitor-count h4 {\n  margin: 0px;\n  font-weight: 700;\n}\n\n.chart-visitor-count span {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 600;\n}\n\n.linechart h5 {\n  font-weight: 700;\n  margin: 0px;\n}\n.linechart {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sales ul {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n}\n\n.sales ul li:first-child span.anticon {\n  color: #b37feb;\n}\n\n.sales ul li:last-child span.anticon {\n  color: #1890ff;\n}\n.sales ul li {\n  color: #8c8c8c;\n  margin-bottom: 3px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n}\n.project-ant h4 {\n  margin: 0px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #141414;\n}\n\nspan.blue {\n  margin-left: 5px;\n  color: #1890ff;\n  font-weight: 600;\n}\n.project-ant h5 {\n  margin: 0px;\n  color: #141414;\n  font-weight: 700;\n}\n\nspan.blue {\n  margin-left: 5px;\n  color: #1890ff;\n  font-weight: 600;\n}\n.project-ant {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a {\n  display: inline-block;\n  padding: 7px 10px;\n  color: #595959;\n  border: 1px solid #d9d9d9;\n  text-align: center;\n  border-right: 1px solid transparent;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:last-child {\n  border-right: 1px solid #d9d9d9;\n  border-radius: 0px 5px 5px 0px;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:first-child {\n  border-radius: 5px 0px 0px 5px;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:hover {\n  color: #1890ff;\n  border: 1px solid #1890ff;\n}\n.antd-pro-pages-dashboard-analysis-style-salesExtra a.active {\n  color: #1890ff;\n  border: 1px solid #1890ff;\n}\n\n.ant-list-box th {\n  text-align: left;\n  border-bottom: 1px solid #0000000d;\n  padding: 8px 0px;\n  color: #8c8c8c;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ant-list-box td {\n  text-align: left;\n  border-bottom: 1px solid #0000000d;\n  padding: 16px 25px;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n}\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.justify-content-center {\n  justify-content: center !important;\n}\n.flex-column {\n  flex-direction: column !important;\n}\n.me-3 {\n  margin-right: 1rem !important;\n}\n.tootip-img {\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  border: 1px solid #fff;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.avatar-group .tootip-img + .tootip-img {\n  margin-left: -10px;\n}\n\n.tootip-img:hover {\n  z-index: 3;\n  cursor: pointer;\n}\n.title-box h5 {\n  margin: 0px;\n}\n\n.text-xs {\n  color: #8c8c8c;\n}\n\n.percent-progress span.ant-progress-text {\n  display: flex;\n  margin-top: -27px;\n  color: #8c8c8c;\n  position: relative;\n  margin-left: 0px;\n}\n/* .percent-progress .ant-progress-outer {\n  margin-right: 0px;\n  padding-right: 0px;\n} */\n\n.percent-progress .ant-progress-status-exception .ant-progress-text {\n  color: #ff4d4f;\n}\n.ant-full-box {\n  width: 100%;\n  border: 1px dashed #d9d9d9;\n  padding: 10px;\n  height: auto;\n  color: #141414;\n  border-radius: 10px;\n}\n.uploadfile {\n  margin-top: 15px;\n}\n\n.uploadfile .ant-upload.ant-upload-select {\n  display: block;\n}\n.ant-timeline-item-tail {\n  left: 7px;\n}\n\n.ant-list-box h5 {\n  font-size: 14px;\n}\n.timeline-box h5 {\n  margin-bottom: 0px;\n  font-weight: 700;\n}\n.timelinelist h5 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.timelinelist span {\n  color: #8c8c8c;\n  font-size: 12px;\n}\n.ant-muse span {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-muse h5 {\n  margin: 0px 0px 15px !important;\n  font-size: 20px;\n}\n.bg-gradient-primary {\n  background-image: linear-gradient(310deg, #2152ff, #21d4fd);\n}\nimg {\n  max-width: 100%;\n}\n.border10 {\n  border-radius: 10px;\n}\n.py-4 {\n  padding: 20px;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n.icon-move-right .anticon-right {\n  color: #40a9ff;\n  margin-left: 2px;\n}\n.icon-move-right {\n  color: #1890ff;\n\n  display: block;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.gradent {\n  background: url(\"../images/info-card-2.jpg\") no-repeat center top;\n  background-size: cover;\n  padding: 15px;\n  border-radius: 15px;\n  color: #fff;\n}\n\n.gradent h5 {\n  color: #fff;\n}\n\n.gradent .ant-typography {\n  color: #fff;\n  font-size: 20px;\n}\n\n.gradent .icon-move-right {\n  color: #fff;\n}\n\n.gradent .icon-move-right .anticon-right {\n  color: #fff;\n}\n.copyright {\n  color: #8c8c8c;\n  margin-top: 7px;\n}\n.copyright .anticon-heart {\n  color: #f5222d;\n  margin: 0px 5px;\n}\n.copyright a {\n  margin: 0px 5px;\n  color: #141414;\n  font-weight: 700;\n}\n.footer-menu ul {\n  margin: 0px;\n  padding: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.footer-menu ul li {\n  list-style: none;\n}\n.footer-menu ul li a {\n  padding: 0.5rem 1rem;\n  display: block;\n  color: #8c8c8c;\n}\nspan.ismobile {\n  display: none;\n  margin-right: 15px;\n  cursor: pointer;\n}\n@media (max-width: 992px) {\n  .footer-menu ul {\n    justify-content: center;\n  }\n  footer.ant-layout-footer {\n    padding: 0px 15px;\n    text-align: center;\n  }\n  .project-ant {\n    display: block;\n  }\n\n  .ant-filtertabs {\n    text-align: right;\n  }\n  .rightside-top span.ant-input-affix-wrapper {\n    width: 200px;\n  }\n\n  .rightside-top {\n    justify-content: flex-end;\n  }\n\n  header.ant-layout-header.subheader {\n    padding: 0px 24px 0px 0px;\n  }\n\n  main.ant-layout-content.content-ant {\n    padding-left: 0px !important;\n  }\n\n  .ant-row {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n  span.ismobile {\n    display: inline-block;\n  }\n  .bar-chart {\n    width: 100% !important;\n    max-width: 100%;\n  }\n  .full-width {\n    max-width: 100% !important;\n  }\n  .bar-chart {\n    width: 100% !important;\n  }\n\n  .icon-move-right {\n    margin-bottom: 15px;\n  }\n  .pageheader {\n    display: block;\n  }\n  .ant-cret img {\n    width: 100%;\n    height: 300px;\n    object-fit: cover;\n  }\n}\n\n.sidebar-color {\n  padding: 1.5rem 0px;\n}\n.theme-color button {\n  margin-right: 8px;\n  border: 0px;\n  width: 20px !important;\n  height: 20px !important;\n  padding: 0px;\n  box-shadow: none;\n  visibility: visible !important;\n  line-height: 20px !important;\n}\n\n.theme-color button:focus {\n  box-shadow: none;\n  border-color: transparent;\n}\n\n.theme-color button span {\n  opacity: 0;\n}\n\n.mb-2 {\n  margin-bottom: 25px;\n}\n\n.sidebarnav-color button {\n  width: 100%;\n  margin-right: 10px;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%), 0 2px 3px -1px rgb(0 0 0 / 7%);\n  height: 40px;\n}\n\n.sidebarnav-color h5 {\n  margin: 0px;\n}\n\n.sidebarnav-color span.ant-typography {\n  color: #8c8c8c;\n}\n\n.sidebarnav-color .trans {\n  margin-top: 1rem;\n  display: flex;\n}\n\n.sidebarnav-color button:last-child {\n  margin-right: 0px;\n}\n\n.ant-docment button {\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.viewstar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 15px;\n}\n\n.viewstar a {\n  display: inline-block;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 0em 0.25em 0.25em 0em;\n  border: 1px solid #ddddde;\n  border-left: 0px;\n  color: #141414;\n}\n\n.viewstar a:first-child {\n  color: #24292e;\n  background-color: #eff3f6;\n  border-color: #cfd3d6;\n  background-image: linear-gradient(180deg, #fafbfc, #eff3f6 90%);\n  border-radius: 0.25em 0 0 0.25em;\n  border-left: 1px solid #ddddde;\n}\n\n.social {\n  text-align: center;\n  margin-top: 25px;\n}\n\n.social button {\n  margin: 0px 5px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.ant-thank {\n  text-align: center;\n  margin-top: 25px;\n}\n.setting-drwer {\n  background: #fff;\n  border-radius: 50%;\n  bottom: 42px;\n  right: 30px;\n  font-size: 1.25rem;\n  z-index: 990;\n  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 16%);\n  width: 52px;\n  height: 52px;\n  text-align: center;\n  line-height: 60px;\n  position: fixed;\n  cursor: pointer;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:active {\n  background: transparent;\n}\n.rightside-top .ant-input {\n  height: 30px;\n}\n.aside-footer {\n  padding-top: 100px;\n}\n.ant-card-body {\n  padding: 16px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li svg path {\n  color: #bfbfbf;\n}\n\n.cardbody .ant-card-body {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.ant-card.criclebox .project-ant {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.ant-card.criclebox table th {\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n.percent-progress .ant-progress-bg {\n  height: 3px !important;\n}\n.uploadfile {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.ant-card.tablespace .ant-card-body {\n  padding: 0px;\n}\n.tablespace .ant-card-head-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n.ant-radio-button-wrapper:first-child {\n  border-radius: 4px 0 0 4px;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li.ant-menu-item-selected\n  path {\n  color: #fff;\n}\n.ant-avatar-group .ant-avatar-square {\n  border-radius: 4px;\n}\n\n.shape-avatar {\n  margin-right: 20px;\n}\n\n.shape-avatar img {\n  border-radius: 4px;\n}\n\n.avatar-info h5 {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 14px;\n  margin-bottom: 3px;\n}\n\n.avatar-info p {\n  font-size: 14px;\n  font-weight: 400;\n  color: #8c8c8c;\n  margin: 0px;\n}\n\n.ant-table-tbody > tr > td h5 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 0px;\n}\n.ant-table-tbody > tr > td p {\n  font-size: 14px;\n  color: #8c8c8c;\n  margin: 0px;\n}\n\n.tag-primary {\n  border-radius: 6px;\n  padding: 2px 12px;\n  font-size: 14px;\n  height: auto;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.ant-employed {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 500;\n  color: #8c8c8c;\n}\n\n.ant-employed a {\n  color: #8c8c8c;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.tag-badge {\n  border-radius: 6px;\n  padding: 2px 12px;\n  font-size: 14px;\n  height: auto;\n  line-height: 24px;\n  font-weight: 600;\n  background: #8c8c8c;\n  color: #fff;\n  outline: none;\n}\n\n.tag-badge:hover {\n  background: #8c8c8c;\n  color: #fff;\n  border-color: #8c8c8c;\n  opacity: 0.9;\n}\n\n.ant-avatar-group {\n  align-items: center;\n}\n\n.mb-24 {\n  margin-bottom: 24px;\n}\n\n.ant-table-thead > tr > th {\n  color: #8c8c8c;\n  font-weight: 700;\n  background-color: transparent;\n  font-size: 12px;\n}\n\n.ant-border-space th:before {\n  display: none;\n}\n.ant-table-tbody > tr > td,\n.ant-table-thead > tr > th {\n  padding: 16px 25px;\n}\n.tablespace {\n  overflow: hidden;\n}\n.ant-table.ant-table-middle .ant-table-title,\n.ant-table.ant-table-middle .ant-table-footer,\n.ant-table.ant-table-middle .ant-table-thead > tr > th,\n.ant-table.ant-table-middle .ant-table-tbody > tr > td,\n.ant-table.ant-table-middle tfoot > tr > th,\n.ant-table.ant-table-middle tfoot > tr > td {\n  padding: 16px 25px;\n}\n\n.avatar-sm {\n  width: 25px;\n}\n\n.ant-progress-project {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ant-progress-project .ant-progress-outer {\n  float: right;\n}\n\n.ant-progress-project .ant-progress-text {\n  margin: 0px 0px 0px 0px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n.semibold {\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.text-sm {\n  font-size: 12px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n.ant-progress-project .ant-progress {\n  margin-right: 15px;\n}\n\n.semibold {\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.text-sm {\n  font-size: 12px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-progress-project .ant-progress-bg {\n  height: 3px !important;\n}\n.ant-table-tbody > tr > td,\n.ant-table-thead > tr > th {\n  white-space: nowrap;\n}\n.h-full {\n  height: 100%;\n}\n@media (min-width: 1200px) {\n  .ant-col.col-img img {\n    height: 196px;\n  }\n  /* .bar-chart {\n    max-width: 438px;\n  } */\n  /* .full-width {\n    max-width: 658px;\n  } */\n}\n@media (max-width: 1024px) {\n  .bar-chart {\n    max-width: 100%;\n  }\n  .full-width {\n    max-width: 100%;\n  }\n  /* .ant-col.mobile-24 {\n    margin-bottom: 24px;\n  } */\n}\n\nbody {\n  overflow: visible !important;\n  width: 100% !important;\n}\n\n.card-info-2 .ant-card-body {\n  height: 100%;\n}\n\n.col-content {\n  flex-grow: 1;\n  padding: 24px;\n  margin-right: 0;\n  border-radius: 8px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.card-content p {\n  font-size: 16px;\n}\n\n.ant-layout-footer {\n  padding: 0px 50px;\n}\n/* sign up start */\n.layout-default.ant-layout.layout-sign-up header.ant-layout-header {\n  background-color: transparent;\n  color: #fff;\n  margin: 0;\n  padding: 0 20px;\n  z-index: 1;\n}\n\n.layout-default .ant-layout-header {\n  display: flex;\n}\n\n.header-col.header-nav {\n  margin-left: auto;\n  width: 100%;\n  margin-right: auto;\n}\n.header-col.header-nav .ant-menu-overflow {\n  justify-content: center;\n}\n\n.header-col.header-nav .ant-menu-horizontal {\n  background: transparent;\n  box-shadow: none;\n  border: 0px;\n}\n\n.layout-default.ant-layout.layout-sign-up {\n  padding: 11px;\n}\n.header-col.header-nav li:after {\n  display: none;\n}\n.sign-up-header {\n  height: 550px;\n  margin-top: -62.8px;\n  padding-top: 137.8px;\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  background-size: cover;\n  background-position: 50%;\n  text-align: center;\n  background: url(\"../images/bg-signup.jpg\") no-repeat center top;\n}\n.header-col.header-brand {\n  white-space: nowrap;\n}\n\n.header-col.header-brand h5 {\n  margin: 0px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.header-col.header-nav {\n  color: #fff;\n  font-weight: 600;\n}\n\n.header-col.header-nav ul li {\n  color: #fff !important;\n}\n\n.header-col.header-nav ul li img {\n  margin-top: -2px;\n  margin-right: 5px;\n}\n.header-col.header-btn button {\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 34px;\n  line-height: 33px;\n}\n.sign-up-header .content {\n  padding-top: 40px;\n  max-width: 480px;\n  margin: auto;\n}\n.sign-up-header * {\n  color: #fff;\n}\n.sign-up-header .content h1 {\n  font-size: 48px;\n  color: #fff;\n}\n.text-lg {\n  font-size: 16px;\n}\n.card-signup .sign-up-gateways .ant-btn {\n  margin-right: 10px;\n  margin-left: 10px;\n  height: 60px;\n  width: 70px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n.card-signup {\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  border-radius: 12px;\n  margin-top: -190px;\n  margin-bottom: 20px;\n}\n.card-signup h5 {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  color: #141414;\n  margin: 0px;\n}\n.header-solid .ant-card-head {\n  border-bottom: 0;\n}\n.card-signup .sign-up-gateways .ant-btn img {\n  width: 20px;\n}\n.sign-up-gateways {\n  text-align: center;\n}\n.m-25,\n.mb-25,\n.my-25 {\n  margin-bottom: 25px;\n}\n.m-25,\n.mt-25,\n.my-25 {\n  margin-top: 25px;\n}\n.text-center {\n  text-align: center;\n}\n.font-semibold {\n  font-weight: 600;\n}\n.text-muted {\n  color: #8c8c8c;\n}\n.ant-input {\n  border-radius: 6px;\n}\n.ant-input {\n  font-weight: 600;\n  color: #8c8c8c;\n}\n.ant-input {\n  height: 40px;\n  border: 1px solid #d9d9d9;\n}\n.font-bold {\n  font-weight: 700;\n}\n.text-dark {\n  color: #141414;\n}\n.ant-btn,\n.ant-radio-group .ant-radio-button-wrapper {\n  font-weight: 600;\n  font-size: 12px;\n  height: 40px;\n  padding: 0 15px;\n  line-height: 40px;\n}\n.ant-btn {\n  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);\n  border-radius: 6px;\n}\n.layout-sign-up .ant-layout-footer {\n  padding: 24px 50px;\n}\n\n.layout-default .ant-layout-footer {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  background: transparent;\n  text-align: center;\n}\n.layout-default .ant-layout-footer .ant-menu-horizontal {\n  border: none;\n  line-height: 1.5;\n  margin: 0 0 30px;\n  background-color: transparent;\n  font-size: 16px;\n}\n.layout-default .ant-layout-footer .ant-menu-horizontal {\n  text-align: center;\n  display: block;\n}\n\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item,\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item-active,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-item-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item:hover,\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-submenu,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu-active,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu-selected,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu:hover {\n  color: #8c8c8c;\n  border: none;\n}\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item-active,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-item-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal > .ant-menu-item:hover,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu-active,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu-selected,\n.layout-default\n  .ant-layout-footer\n  .ant-menu-horizontal\n  > .ant-menu-submenu:hover {\n  color: #262626;\n}\n.layout-default.ant-layout.layout-sign-up .ant-layout-footer ul li:after {\n  display: none;\n}\n.layout-default.ant-layout.layout-sign-up footer.ant-layout-footer ul li a svg {\n  width: 18px;\n  height: 18px;\n}\n.layout-default .ant-layout-footer .menu-nav-social a svg {\n  fill: #8c8c8c;\n  vertical-align: middle;\n}\n.layout-default .ant-layout-footer .menu-nav-social a:hover svg {\n  fill: #1890ff;\n}\n.layout-default .ant-layout-footer .copyright a {\n  color: inherit;\n  font-weight: normal;\n}\n/* signin start csss */\n.layout-default.layout-signin header.ant-layout-header {\n  display: flex;\n  position: relative;\n  background-color: #fff;\n  color: #141414;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  flex-direction: row;\n  padding: 0 50px;\n  height: 64px;\n  line-height: 64px;\n}\n.fill-muted {\n  fill: #8c8c8c;\n}\n.layout-default .ant-layout-header .header-brand h5 {\n  white-space: nowrap;\n\n  color: #141414;\n  margin: 0;\n}\n.layout-default .ant-layout-header .header-nav a svg {\n  margin-right: 5px;\n}\n.layout-default .ant-layout-header .header-nav a span,\n.layout-default .ant-layout-header .header-nav a svg {\n  vertical-align: middle;\n}\n.layout-default .ant-layout-header .header-nav a {\n  color: #141414;\n  padding: 6px 12px;\n  font-weight: 400;\n}\n\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-item,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-item-active,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-item-selected,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-item:hover,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-submenu,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-submenu-active,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-submenu-selected,\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-submenu:hover {\n  color: #8c8c8c;\n  font-weight: 600;\n  border: none;\n}\n.layout-default\n  .ant-layout-header\n  .header-nav\n  .ant-menu-horizontal\n  > .ant-menu-item {\n  padding: 0;\n}\n.sign-in {\n  padding: 0 20px;\n}\n.layout-default .ant-layout-content {\n  padding-top: 40px;\n}\n.font-regular {\n  font-weight: 400;\n}\n.signin h1 {\n  font-size: 48px;\n  font-weight: 700;\n  color: #141414;\n}\n\n.signin h5 {\n  font-weight: 400;\n  color: #8c8c8c;\n  font-size: 20px;\n  white-space: normal;\n}\n.ant-row.ant-form-item.username {\n  display: block;\n}\n\n.ant-row.ant-form-item.username\n  .ant-col.ant-form-item-label\n  .ant-form-item-required:before {\n  display: none;\n}\n\n.ant-row.ant-form-item.username .ant-col.ant-form-item-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #141414;\n}\n.signin .ant-form-item-control-input button.ant-switch {\n  margin-right: 5px;\n}\n.text-dark {\n  color: #141414;\n}\n.sign-img img {\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  display: block;\n}\n.layout-signin {\n  background: #fff;\n}\n.layout-signin footer.ant-layout-footer svg {\n  width: 18px;\n  height: 18px;\n}\n\n.layout-signin footer.ant-layout-footer ul li:after {\n  display: none;\n}\n.layout-default .ant-layout-footer .copyright {\n  font-size: 16px;\n  color: #8c8c8c;\n}\n\n.row-col .ant-row {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.layout-default.ant-layout.layout-sign-up .header-col.header-brand h5 {\n  color: #fff;\n}\n\n.layout-default.ant-layout.layout-sign-up .header-col.header-nav a {\n  color: #fff;\n}\n\n.layout-default.ant-layout.layout-sign-up\n  .header-col.header-nav\n  svg\n  path.fill-muted {\n  fill: #fff;\n}\n/* sign in end */\n\n@media (min-width: 768px) {\n  .sign-img img {\n    margin: 0;\n  }\n  .card-signup {\n    margin-bottom: 120px;\n  }\n  .card-signup .sign-up-gateways .ant-btn {\n    width: 100px;\n  }\n}\n\n/* end sign up */\n\n.rightside-top .signin {\n  display: inline-flex;\n}\n\n.rightside-top .signin svg {\n  margin-right: 5px;\n}\n\nbutton.ant-btn.bell strong {\n  position: absolute;\n  top: -1px;\n  right: -9px;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  background: #f5222d;\n  border-radius: 100%;\n  text-align: center;\n  line-height: normal;\n  font-weight: normal;\n  color: #fff;\n}\n/* old css end */\n\n.layout-dashboard .ant-layout-footer {\n  background: transparent;\n  margin: 0 20px 20px 20px;\n  padding: 0;\n}\n\n.layout-dashboard .ant-layout-content {\n  padding: 0;\n  margin: 0 20px 0;\n}\n.m-10,\n.mr-10,\n.mx-10 {\n  margin-right: 10px !important;\n}\n\n.ant-table-tbody > tr > td h6 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.layout-dashboard .header-control .header-search input.ant-input {\n  height: auto;\n}\n\nsmall.redtext {\n  color: red;\n}\n\n.full-width path {\n  fill: transparent;\n}\n\n.bar-chart line.apexcharts-xaxis-tick {\n  stroke: transparent;\n}\n\nsection.ant-layout.layout-content .ant-layout-content.content-ant {\n  padding: 0px !important;\n}\n\n.layout-dashboard .ant-card {\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n}\n\n.card-credit {\n  background-image: url(\"../images/info-card-3.jpg\");\n  background-position: 50%;\n  background-size: cover;\n  border: none;\n}\n.card-credit * {\n  color: #fff;\n}\n\n.card-credit .card-number {\n  word-spacing: 10px;\n  font-weight: 600;\n  margin-bottom: 45px;\n  font-size: 20px;\n}\n.ant-card-head-wrapper {\n  min-height: 72px;\n}\n.card-credit .ant-card-body {\n  padding-top: 15px;\n}\n.card-credit .card-footer {\n  display: flex;\n  align-items: flex-end;\n}\n.m-auto,\n.ml-auto {\n  margin-left: auto !important;\n}\n.m-30,\n.mr-30,\n.mx-30 {\n  margin-right: 30px !important;\n}\n.card-credit .card-footer h6,\n.card-credit .card-footer p {\n  margin-bottom: 0;\n}\n.card-credit .col-logo img {\n  max-width: 50px;\n}\n.card-credit .card-footer h6 {\n  font-weight: 700;\n}\n.width-100 {\n  width: 100%;\n}\n.p-20 {\n  padding: \"0px 20px 0px 0px\";\n}\n.layout-default .ant-layout-content.p-0 {\n  padding: 0px;\n}\n.pt {\n  padding-top: 0px;\n}\n\n.widget-2 .icon {\n  width: 64px;\n  height: 64px;\n  margin: auto;\n  background-color: #1890ff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.widget-2 .ant-statistic-title h6 {\n  font-weight: 600;\n}\n.widget-2 .ant-statistic-title p {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.widget-2 .ant-statistic-content {\n  font-family: open sans, Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 12px 16px;\n  border-top: 1px solid #f5f5f5;\n  text-align: center;\n}\n.widget-2 .ant-statistic-title {\n  text-align: center;\n  padding: 16px;\n}\n\n.widget-2 .ant-card-body {\n  padding: 0;\n}\n.widget-2 .icon img {\n  width: 30px;\n}\n\n.ant-row-flex-middle {\n  align-items: center;\n}\n.d-flex {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.payment-method-card.ant-card {\n  box-shadow: none;\n  word-spacing: 10px;\n}\n\n.payment-method-card.ant-card img {\n  width: 40px;\n}\n.payment-method-card.ant-card .ant-card-body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.payment-method-card.ant-card .ant-btn {\n  margin-right: -20px;\n}\n\n.ant-btn.ant-btn-link.ant-edit-link {\n  font-weight: 600;\n  font-size: 12px;\n  height: 40px;\n  padding: 0 15px;\n  box-shadow: none;\n}\n\n.ant-btn.ant-btn-link.ant-edit-link img {\n  width: 20px;\n}\n.payment-method-card.ant-card .ant-btn {\n  margin-right: -20px;\n}\n\n.fill-gray-7 {\n  fill: #8c8c8c !important;\n}\n\n.payment-method-card.ant-card h6 {\n  font-weight: 600;\n  margin-bottom: 0;\n  color: #141414;\n}\n.m-0 {\n  margin: 0px;\n}\n\n.ant-card.ant-card-bordered.payment-method-card .ant-card-body {\n  padding-top: 16px;\n}\n\n.header-solid .ant-card-head {\n  border-bottom: 0;\n}\n.invoice-list .ant-list-item,\n.transactions-list .ant-list-item {\n  padding: 11px 0;\n  border-bottom: 0;\n}\n.ant-invoice-card .ant-card-body {\n  padding-top: 0px;\n}\n.invoice-list .ant-list-item-meta-title,\n.transactions-list .ant-list-item-meta-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.invoice-list .ant-list-item-meta-description,\n.transactions-list .ant-list-item-meta-description {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.invoice-list .ant-list-item-action .ant-btn,\n.transactions-list .ant-list-item-action .ant-btn {\n  font-weight: 600;\n  color: #141414;\n  box-shadow: none;\n}\n\n.ant-btn > svg,\n.ant-btn > svg + span {\n  vertical-align: middle;\n}\n.invoice-list .amount,\n.transactions-list .amount {\n  font-size: 14px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.card-billing-info.ant-card {\n  box-shadow: none;\n  background-color: #fafafa;\n  border: 1px solid #f5f5f5;\n}\n\n.ant-descriptions .ant-descriptions-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 14px;\n}\n\n.fill-danger {\n  fill: #ff4d4f;\n}\n.card-billing-info.ant-card .darkbtn {\n  color: #8c8c8c;\n}\n\n.col-action {\n  display: flex;\n}\n\n.card-billing-info .col-action button {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n  box-shadow: none;\n}\n\n.ant-descriptions .ant-descriptions-row > td,\n.ant-descriptions .ant-descriptions-row > th {\n  padding-bottom: 6px;\n}\n\n.ant-descriptions .ant-descriptions-item-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.ant-descriptions .ant-descriptions-item-content {\n  font-size: 13px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.ant-descriptions .ant-descriptions-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 14px;\n}\n\n.card-billing-info.ant-card .ant-descriptions-header {\n  margin-bottom: 0px;\n}\n\n.card-header-date {\n  margin-bottom: 0;\n  font-weight: 700;\n  color: #8c8c8c;\n}\n\n.card-header-date > * {\n  vertical-align: middle;\n}\n.card-header-date svg {\n  margin-right: 5px;\n}\n\n.transactions-list .amount {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.text-light-danger {\n  background: #fde3cf;\n  color: #f56a00;\n}\n.text-fill {\n  color: #52c41a;\n  background: #edf9e7;\n}\n.text-danger {\n  color: #f5222d;\n}\n.text-success {\n  color: #52c41a;\n}\n\n.transactions-list .ant-list-item-meta {\n  align-items: center;\n}\n\n.text-warning {\n  background: rgb(255, 252, 231);\n  color: #fadb14;\n}\n.text-warning-b {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fadb14;\n}\n.ant-card.ant-list-yes .ant-list-header {\n  border: 0px;\n}\n\n.ant-card.ant-list-yes .ant-list-header h6 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n  margin: 6px 0;\n}\n\n.ant-list.ant-list-split.transactions-list.ant-newest .ant-list-header {\n  padding-top: 0px;\n}\n.profile-nav-bg {\n  height: 300px;\n  margin-top: -137.8px;\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  background-size: cover;\n  background-position: 50%;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  span.ant-page-header-heading-title {\n  color: #fff;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  span.ant-breadcrumb-separator {\n  color: #fff;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  span.ant-breadcrumb-link {\n  color: #fff;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  .header-control\n  svg\n  path {\n  fill: #fff;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  .btn-sign-in {\n  color: #fff;\n}\n\n.layout-profile .ant-layout-header {\n  margin: 10px 20px;\n}\n.card-profile-head .ant-card-head {\n  border-bottom: 0px;\n  padding: 0px 16px;\n}\n\n.card-profile-head {\n  margin: -53px 0 24px;\n}\n\n.card-profile-head .ant-card-head .ant-avatar {\n  box-shadow: 0 5px 10px rgb(0 0 0 / 12%);\n  border-radius: 8px;\n  margin: 0;\n}\n\n.card-profile-head .ant-card-head .avatar-info {\n  margin-left: 16px;\n}\n\n.ant-card-head-title p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 0;\n}\n\n.card-profile-head .ant-card-head .avatar-info h4 {\n  font-size: 24px;\n}\n\n.card-profile-head .ant-card-head .avatar-info h4 {\n  font-size: 24px;\n}\n\n.card-profile-head .ant-radio-group .ant-radio-button-wrapper {\n  height: auto;\n  font-weight: 700;\n}\n.ant-radio-button-wrapper {\n  color: #595959;\n}\n\n.layout-profile .ant-card-head {\n  padding: 0 16px;\n}\n\n.settings-list {\n  list-style: none;\n  padding: 0;\n}\n.settings-list > li:first-child {\n  padding-top: 0;\n}\n.settings-list > li {\n  padding: 12px 0;\n}\n\n.settings-list > li h6 {\n  font-size: 12px;\n  color: #8c8c8c;\n  margin: 0;\n  font-weight: 700;\n}\n.settings-list > li span {\n  margin-left: 16px;\n  color: #141414;\n}\n.ant-btn-link {\n  box-shadow: none;\n}\n.card-profile-information hr {\n  opacity: 0.2;\n}\n\n.p-5,\n.pr-5,\n.px-5 {\n  padding-right: 5px !important;\n}\n.p-5,\n.pl-5,\n.px-5 {\n  padding-left: 5px !important;\n}\n.m-5,\n.mr-5,\n.mx-5 {\n  margin-right: 5px !important;\n}\n.m-5,\n.ml-5,\n.mx-5 {\n  margin-left: 5px !important;\n}\n\n.card-profile-information .ant-descriptions .ant-descriptions-row > td,\n.card-profile-information .ant-descriptions .ant-descriptions-row > th {\n  padding-bottom: 16px;\n}\n\n.conversations-list .ant-list-item-meta-description {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.conversations-list .ant-avatar {\n  border-radius: 10.5px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n}\n.conversations-list .ant-list-item {\n  padding: 14px 0;\n}\n\n.ant-card-head-title p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 0;\n}\n\n.ant-card-head-title h6 {\n  margin-bottom: 0;\n}\n\n.card-project.ant-card {\n  box-shadow: none;\n  border: none;\n}\n\n.card-project.ant-card .ant-card-cover img {\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n}\n\n.card-project.ant-card .card-tag,\n.card-project.ant-card p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 5px;\n}\n.card-project.ant-card h5 {\n  font-weight: 600;\n  font-size: 20px;\n}\n.card-project.ant-card .card-tag,\n.card-project.ant-card p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 5px;\n}\n.card-project.ant-card p {\n  margin-bottom: 0;\n}\n.card-project.ant-card .ant-card-body {\n  padding: 16px 0 0;\n}\n\n.card-project.ant-card .card-footer {\n  margin-top: 22px;\n}\n\n.avatar-chips .ant-avatar-image {\n  border: 1px solid #fff;\n}\n.avatar-chips .ant-avatar-image:hover,\n.avatar-chips .ant-space-item:hover {\n  z-index: 1;\n}\n\n.projects-uploader {\n  height: 100%;\n  border-radius: 8px;\n  border-color: #d9d9d9;\n}\n.projects-uploader .ant-upload {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.projects-uploader .ant-upload-list.ant-upload-list-picture-card {\n  height: 100%;\n}\n\n.projects-uploader .ant-upload.ant-upload-select-picture-card {\n  background-color: transparent;\n}\n\n.projects-uploader svg {\n  width: 20px;\n  height: 20px;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.layout-dashboard-rtl {\n  background: transparent;\n  text-align: right;\n  direction: rtl;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-item .icon,\n.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-submenu .icon {\n  margin-left: 11px;\n  margin-right: 0;\n}\n\n.layout-dashboard-rtl .ant-timeline-item-tail {\n  right: 6.5px;\n  left: auto;\n}\n.layout-dashboard-rtl .ant-timeline-item-content {\n  margin: 0 33px 0 0;\n}\n\n.ant-timeline-item-head {\n  width: 15px;\n  height: 15px;\n  border-width: 3px;\n}\n\n.layout-dashboard-rtl .ant-radio-button-wrapper:first-child {\n  border-right-width: 1px;\n  border-radius: 0 4px 4px 0;\n}\n.layout-dashboard-rtl .ant-list-box td {\n  text-align: right;\n}\n\n.layout-dashboard-rtl .ant-space-horizontal {\n  direction: ltr;\n}\n\n.layout-dashboard-rtl .ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-right: 8px;\n  margin-left: 0px;\n}\n.layout-dashboard-rtl .setting-drwer {\n  left: 30px;\n  right: auto;\n}\n\n.layout-dashboard-rtl ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light {\n  text-align: right;\n}\n\n.layout-dashboard-rtl .avatar-group.mt-2 {\n  direction: ltr;\n}\n.ant-list-box table tr:hover td {\n  background: #fafafa;\n}\n.layout-dashboard-rtl .icon-box {\n  margin-left: 0px;\n  margin-right: auto;\n}\n.layout-dashboard-rtl .m-10,\n.layout-dashboard-rtl .mr-10,\n.layout-dashboard-rtl .mx-10 {\n  margin-left: 10px !important;\n}\n\n.layout-dashboard-rtl .ant-progress-show-info .ant-progress-outer {\n  margin-right: 0px;\n  padding-right: 0px;\n}\n\n.layout-dashboard-rtl .ant-badge-count,\n.layout-dashboard-rtl .ant-badge-dot,\n.layout-dashboard-rtl .ant-badge .ant-scroll-number-custom-component {\n  left: 0;\n  right: auto;\n  transform: translate(-50%, -50%);\n}\n\n.layout-dashboard-rtl .header-control .btn-sign-in svg {\n  margin-left: 4px;\n  margin-right: 0px;\n}\n\n.ant-drawer.drawer-sidebar.drawer-sidebar-rtl\n  aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {\n  left: auto;\n  right: 0px;\n  direction: rtl;\n}\n\n.layout-dashboard.layout-dashboard-rtl .header-control span.ant-badge {\n  margin: 0px 7px;\n}\n\n.layout-dashboard.layout-dashboard-rtl span.ant-input-prefix {\n  margin-right: 0px;\n  margin-left: 4px;\n}\n\n.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl button.ant-drawer-close {\n  left: 0px;\n  right: auto;\n  margin-right: 0px;\n  margin-left: var(--scroll-bar);\n  padding-left: calc(20px - var(--scroll-bar));\n}\n\n.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl button.ant-drawer-close {\n  left: 0px;\n  right: auto;\n  margin-right: 0px;\n  margin-left: var(--scroll-bar);\n  padding-left: calc(20px - var(--scroll-bar));\n}\n\n.settings-drawer.settings-drawer-rtl .sidebarnav-color button {\n  margin-right: 0px;\n  margin-left: 10px;\n}\n\n.settings-drawer.settings-drawer-rtl .viewstar a:first-child {\n  border-radius: 0em 0.25em 0.25em 0;\n  border-right: 1px solid #ddddde;\n}\n\n.settings-drawer.settings-drawer-rtl .viewstar a {\n  border-radius: 0.25em 0 0 0.25em;\n  border: 1px solid #ddddde;\n  border-right: 0px;\n}\n\n.social svg path {\n  fill: #fff;\n}\n\n.settings-drawer.settings-drawer-rtl .social svg {\n  margin-right: 0px;\n  margin-left: 5px;\n}\n\n.social svg {\n  width: 15px;\n  height: 15px;\n}\n\n.layout-dashboard .ant-affix .ant-layout-header {\n  background: #fff;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  margin: 10px 20px;\n  z-index: 10;\n}\n\naside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.active-route\n  a.active {\n  background: transparent;\n  box-shadow: none;\n}\n.uploadfile.pb-15 {\n  padding-bottom: 16px;\n}\n\n.ant-row.ant-form-item.aligin-center .ant-form-item-control-input-content {\n  display: flex;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.uploadfile.shadow-none\n  .ant-upload.ant-upload-select.ant-upload-select-text\n  .ant-btn.ant-full-box {\n  box-shadow: none;\n}\n\n.ant-btn-dashed {\n  color: rgba(0, 0, 0, 0.65);\n}\nbutton.ant-btn.ant-btn-dashed.ant-full-box svg {\n  width: 16px;\n  height: 16px;\n}\n\n.ant-btn-dashed.active,\n.ant-btn-dashed:active {\n  color: #096dd9;\n  background-color: #fff;\n  border-color: #096dd9;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile\n  .header-control\n  span.ant-input-affix-wrapper.header-search\n  .anticon-search\n  svg\n  path {\n  fill: #8c8c8c;\n}\n\n\n/* Profits page */\n.profits-page .ant-card {\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgb(0 0 0 / 4%);\n}\n\n.profits-page .profit-hero .ant-card-body {\n  padding: 24px;\n}\n\n.profits-page .profit-hero-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n}\n\n.profits-page .profit-account {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  min-width: 0;\n}\n\n.profits-page .profit-account-icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #e6f7ff;\n  color: #1890ff;\n  font-size: 22px;\n  flex: 0 0 auto;\n}\n\n.profits-page .profit-account-title {\n  margin: 0;\n  color: #141414;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.profits-page .profit-account-subtitle {\n  color: #8c8c8c;\n  margin-top: 4px;\n}\n\n.profits-page .profit-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.profits-page .profit-overview {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.profits-page .profit-overview-item {\n  min-height: 86px;\n  padding: 16px 18px;\n  border-right: 1px solid #f0f0f0;\n  border-bottom: 1px solid #f0f0f0;\n  background: #fff;\n}\n\n.profits-page .profit-overview-item:nth-child(3n) {\n  border-right: 0;\n}\n\n.profits-page .profit-overview-item:nth-child(n + 4) {\n  border-bottom: 0;\n}\n\n.profits-page .profit-overview-label {\n  color: #8c8c8c;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.profits-page .profit-overview-value {\n  color: #141414;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.25;\n  word-break: keep-all;\n}\n\n.profits-page .profit-toolbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.profits-page .profit-filter-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.profits-page .profit-chart-range {\n  display: flex;\n  justify-content: space-between;\n  color: #8c8c8c;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n.profits-page .profit-table-card .ant-card-body {\n  padding: 0;\n}\n\n.profits-page .profit-table-card .ant-card-head {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n@media (max-width: 768px) {\n  .profits-page .profit-hero-top {\n    flex-direction: column;\n  }\n\n  .profits-page .profit-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .profits-page .profit-overview {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .profits-page .profit-overview-item,\n  .profits-page .profit-overview-item:nth-child(3n) {\n    border-right: 1px solid #f0f0f0;\n  }\n\n  .profits-page .profit-overview-item:nth-child(2n) {\n    border-right: 0;\n  }\n\n  .profits-page .profit-overview-item:nth-child(n + 4) {\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .profits-page .profit-overview-item:nth-child(n + 5) {\n    border-bottom: 0;\n  }\n\n  .profits-page .profit-overview-value {\n    font-size: 18px;\n  }\n\n  .profits-page .profit-filter-row,\n  .profits-page .profit-filter-row .ant-picker,\n  .profits-page .profit-filter-row .ant-input,\n  .profits-page .profit-filter-row .ant-btn {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
